/**
 *
 * @param {*} skill_id
 * @param {*} skill_lv
 * @param {*} src
 * @param {*} target
 * @returns
 */
const BL_PC = 'Player'
export function getSkillRatio(wd, skill_id, skill_lv, src, target) {
	//functions that use src or target datas
	//base level modifier for skill ratio
	// console.log(src)
	function RE_LVL_DMOD(lv) {
		return (src.baseLevel / lv).toFixed(2)
	}
	//get source active buff
	function getSCE(skill_id) {
		//TODO
		return 0
	}
	//get target active buff
	function tgetSCE(skill_id) {
		//TODO
		return 0
	}

	let skillratio = 100
	// let wd = {
	// 	//TODO
	// 	miscflag: 0,
	// }

	//if non player, sd = null
	let sd = BL_CAST(BL_PC, src)
	let tsd = BL_CAST(BL_PC, target)

	//bonuses
	let sc = status_get_sc(src)
	let tsc = status_get_sc(target)
	//stats
	let sstatus = status_get_status_data(src)
	let tstatus = status_get_status_data(target)
	let i = 0

	let BREAK_NECK = 0x0
	// let OPTION_HIDE = 0x0
	// let OPTION_CLOAK = 0x0
	// let OPTION_CHASEWALK = 0x0
	let nullptr = 0
	let areGeneticSkillsUpdated = false
	let areSorcererSkillsUpdated = false
	let areMechanicSkillsUpdated = false
	let areArchBishopSkillsUpdated = false
	let areSuraSkillsUpdated = false
	let areShadowChaserSkillsUpdated = false
	let areRangerSkillsUpdated = false
	let areMaestroWandererSkillsUpdated = false
	switch (skill_id) {
		case 'SM_BASH':
		case 'MS_BASH':
			skillratio += 30 * skill_lv
			break
		case 'SM_MAGNUM':
		case 'MS_MAGNUM':
			skillratio += 20 * skill_lv
			// if (wd.miscflag === 1) skillratio += 20 * skill_lv
			// //Inner 3x3 circle takes 100%+20%*level damage [Playtester]
			// else skillratio += 10 * skill_lv //Outer 5x5 circle takes 100%+10%*level damage [Playtester]
			break
		case 'MC_MAMMONITE':
			skillratio += 50 * skill_lv
			break
		case 'HT_POWER':
			skillratio += -50 + 8 * sstatus.str
			break
		case 'AC_DOUBLE':
		case 'MA_DOUBLE':
			skillratio += 10 * (skill_lv - 1)
			break
		case 'AC_SHOWER':
		case 'MA_SHOWER':
			skillratio += 50 + 10 * skill_lv
			break
		case 'AC_CHARGEARROW':
		case 'MA_CHARGEARROW':
			skillratio += 50
			break
		case 'KN_PIERCE':
			skillratio += 10 * skill_lv
			if (
				sc &&
				getSCE('SC_CHARGINGPIERCE_COUNT') &&
				getSCE('SC_CHARGINGPIERCE_COUNT').val1 >= 10
			)
				//Dragon Knight Skill
				skillratio *= 2
			break
		case 'ML_PIERCE':
			skillratio += 10 * skill_lv
			break
		case 'MER_CRASH':
			skillratio += 10 * skill_lv
			break
		case 'KN_SPEARSTAB':
			skillratio += 20 * skill_lv
			break
		case 'KN_SPEARBOOMERANG':
			skillratio += 50 * skill_lv
			break
		case 'KN_BRANDISHSPEAR':
			skillratio += -100 + 400 + 100 * skill_lv + sstatus.str * 3
			break
		//mercenary brandish spear
		case 'ML_BRANDISH':
			{
				let ratio = 100 + 20 * skill_lv

				skillratio += -100 + ratio
				if (skill_lv > 3 && wd.miscflag === 0) skillratio += ratio / 2
				if (skill_lv > 6 && wd.miscflag === 0) skillratio += ratio / 4
				if (skill_lv > 9 && wd.miscflag === 0) skillratio += ratio / 8
				if (skill_lv > 6 && wd.miscflag === 1) skillratio += ratio / 2
				if (skill_lv > 9 && wd.miscflag === 1) skillratio += ratio / 4
				if (skill_lv > 9 && wd.miscflag === 2) skillratio += ratio / 2
			}
			break
		case 'KN_BOWLINGBASH':
		case 'MS_BOWLINGBASH':
			skillratio += 40 * skill_lv
			break
		case 'AS_GRIMTOOTH':
			skillratio += 20 * skill_lv
			break
		case 'AS_POISONREACT':
			skillratio += 30 * skill_lv
			break
		case 'AS_SONICBLOW':
			skillratio += 100 + 100 * skill_lv
			if (tstatus.hp < tstatus.max_hp / 2) skillratio += skillratio / 2
			break
		case 'TF_SPRINKLESAND':
			skillratio += 30
			break
		case 'MC_CARTREVOLUTION':
			skillratio += 50
			if (sd && sd.cart_weight)
				skillratio += (100 * sd.cart_weight) / sd.cart_weight_max
			// +1% every 1% weight
			else if (!sd) skillratio += 100 //Max damage for non players.
			break
		case 'NPC_PIERCINGATT':
			skillratio += -25 //75% base damage
			break
		case 'NPC_COMBOATTACK':
			skillratio += 25 * skill_lv
			break
		case 'NPC_RANDOMATTACK':
		case 'NPC_WATERATTACK':
		case 'NPC_GROUNDATTACK':
		case 'NPC_FIREATTACK':
		case 'NPC_WINDATTACK':
		case 'NPC_POISONATTACK':
		case 'NPC_HOLYATTACK':
		case 'NPC_DARKNESSATTACK':
		case 'NPC_UNDEADATTACK':
		case 'NPC_TELEKINESISATTACK':
		case 'NPC_BLOODDRAIN':
		case 'NPC_ACIDBREATH':
		case 'NPC_DARKNESSBREATH':
		case 'NPC_FIREBREATH':
		case 'NPC_ICEBREATH':
		case 'NPC_ICEBREATH2':
		case 'NPC_THUNDERBREATH':
		case 'NPC_HELLJUDGEMENT':
		case 'NPC_HELLJUDGEMENT2':
		case 'NPC_PULSESTRIKE':
			skillratio += 100 * (skill_lv - 1)
			break
		case 'NPC_REVERBERATION_ATK':
			skillratio += 400 + 200 * skill_lv
			break
		case 'RG_BACKSTAP':
			if (
				sd &&
				sd.status.weapon === 'W_BOW'
				// &&
				// battle_config.backstab_bow_penalty
			)
				skillratio += (200 + 40 * skill_lv) / 2
			else skillratio += 200 + 40 * skill_lv
			break
		case 'RG_RAID':
			skillratio += -100 + 50 + skill_lv * 150
			break
		case 'RG_INTIMIDATE':
			skillratio += 30 * skill_lv
			break
		case 'CR_SHIELDCHARGE':
			skillratio += 20 * skill_lv
			break
		case 'CR_SHIELDBOOMERANG':
			skillratio += -100 + skill_lv * 80

			break
		case 'NPC_DARKCROSS':
		case 'CR_HOLYCROSS':
			if (sd && sd.status.weapon === 'W_2HSPEAR')
				skillratio += 70 * skill_lv
			else skillratio += 35 * skill_lv
			break
		case 'AM_DEMONSTRATION':
			skillratio += 20 * skill_lv
			break
		case 'AM_ACIDTERROR':
			skillratio += -100 + 200 * skill_lv
			if (sd && pc_checkskill(sd, 'AM_LEARNINGPOTION')) skillratio += 100 // !TODO: What's this bonus increase?
			break
		case 'MO_FINGEROFFENSIVE':
			skillratio += 500 + skill_lv * 200
			if (tsc && tgetSCE('SC_BLADESTOP')) skillratio += skillratio / 2
			break
		case 'MO_INVESTIGATE':
			skillratio += -100 + 100 * skill_lv
			if (tsc && tgetSCE('SC_BLADESTOP')) skillratio += skillratio / 2
			break
		case 'MO_EXTREMITYFIST':
			skillratio += 100 * (7 + (sstatus.sp - 1) / 10)
			if (wd.miscflag & 1) skillratio *= 2 // More than 5 spirit balls active
			skillratio = Math.min(500000, skillratio) //We stop at roughly 50k SP for overflow protection
			break
		case 'MO_TRIPLEATTACK':
			skillratio += 20 * skill_lv
			break
		case 'MO_CHAINCOMBO':
			skillratio += 150 + 50 * skill_lv
			if (sd && sd.status.weapon === 'W_KNUCKLE') skillratio *= 2
			break
		case 'MO_COMBOFINISH':
			skillratio += 450 + 50 * skill_lv + sstatus.str // !TODO: How does STR play a role?
			if (getSCE('SC_GT_ENERGYGAIN'))
				skillratio += (skillratio * 50) / 100
			break
		case 'BA_MUSICALSTRIKE':
		case 'DC_THROWARROW':
			skillratio += 10 + 40 * skill_lv
			break
		case 'CH_TIGERFIST':
			skillratio += 400 + 150 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			if (getSCE('SC_GT_ENERGYGAIN'))
				skillratio += (skillratio * 50) / 100
			break
		case 'CH_CHAINCRUSH':
			skillratio += -100 + 200 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			if (getSCE('SC_GT_ENERGYGAIN'))
				skillratio += (skillratio * 50) / 100
			break
		case 'CH_PALMSTRIKE':
			skillratio += 100 + 100 * skill_lv + sstatus.str // !TODO: How does STR play a role?
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'LK_HEADCRUSH':
			skillratio += 40 * skill_lv
			break
		case 'LK_JOINTBEAT':
			skillratio += 10 * skill_lv - 50
			if (
				wd.miscflag & BREAK_NECK ||
				(tsc &&
					tgetSCE('SC_JOINTBEAT') &&
					tgetSCE('SC_JOINTBEAT').val2 & BREAK_NECK)
			)
				// The 2x damage is only for the BREAK_NECK ailment.
				skillratio *= 2
			break
		// Renewal: skill ratio applies to entire damage [helvetica]
		case 'LK_SPIRALPIERCE':
			skillratio += 50 + 50 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			if (
				sc &&
				getSCE('SC_CHARGINGPIERCE_COUNT') &&
				getSCE('SC_CHARGINGPIERCE_COUNT').val1 >= 10
			)
				skillratio *= 2
			break
		case 'ML_SPIRALPIERCE':
			skillratio += 50 + 50 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'ASC_METEORASSAULT':
			skillratio += 100 + 120 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SN_SHARPSHOOTING':
			if (src.type === 'BL_MOB') {
				// TODO: Did these formulas change in the renewal balancing?
				if (wd.miscflag & 2)
					// Splash damage bonus
					skillratio += -100 + 140 * skill_lv
				else skillratio += 100 + 50 * skill_lv
				break
			}
		// Fall through
		case 'MA_SHARPSHOOTING':
			skillratio += -100 + 300 + 300 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'CR_ACIDDEMONSTRATION':
			skillratio += -100 + 200 * skill_lv + sstatus.int_ + tstatus.vit // !TODO: Confirm status bonus
			if (target.type === BL_PC) skillratio /= 2
			break
		case 'CG_ARROWVULCAN':
			skillratio += 400 + 100 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'AS_SPLASHER':
			skillratio += -100 + 400 + 100 * skill_lv
			if (sd) skillratio += 20 * pc_checkskill(sd, 'AS_POISONREACT')
			break
		case 'ASC_BREAKER':
			skillratio += -100 + 150 * skill_lv + sstatus.str + sstatus.int_ // !TODO: Confirm stat modifier
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'PA_SACRIFICE':
			skillratio += -10 + 10 * skill_lv
			break
		case 'PA_SHIELDCHAIN':
			skillratio = -100 + 300 + 200 * skill_lv

			if (sd !== nullptr) {
				let index = sd.equip_index['EQI_HAND_L']

				// Damage affected by the shield's weight and refine.
				if (
					index !== 0 &&
					sd.inventory_data[index] !== nullptr &&
					sd.inventory_data[index].Type === 'Armor'
				) {
					skillratio +=
						sd.inventory_data[index].Weight / 10 +
						4 * sd.inventory.u.items_inventory[index].refine
				}

				// Damage affected by shield mastery
				if (sc !== nullptr && getSCE('SC_SHIELD_POWER')) {
					skillratio +=
						skill_lv * 14 * pc_checkskill(sd, 'IG_SHIELD_MASTERY')
				}
			}

			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_SHIELD_POWER'))
				// Whats the official increase? [Rytech]
				skillratio += (skillratio * 50) / 100
			break
		case 'WS_CARTTERMINATION':
			i = 10 * (16 - skill_lv)
			if (i < 1) i = 1
			//Preserve damage ratio when max cart weight is changed.
			if (sd && sd.cart_weight)
				skillratio +=
					((sd.cart_weight / i) * 80000) /
					// battle_config.max_cart_weight -
					100
			else if (!sd) skillratio += 80000 / i - 100
			break
		case 'TK_DOWNKICK':
		case 'TK_STORMKICK':
			skillratio += 60 + 20 * skill_lv
			break
		case 'TK_TURNKICK':
		case 'TK_COUNTER':
			skillratio += 90 + 30 * skill_lv
			break
		case 'TK_JUMPKICK':
			//Different damage formulas depending on damage trigger
			if (
				sc &&
				getSCE('SC_COMBO') &&
				getSCE('SC_COMBO').val1 === skill_id
			)
				skillratio += -100 + 4 * status_get_lv(src)
			//Tumble formula [4%*baselevel]
			else if (wd.miscflag) {
				skillratio += -100 + 4 * status_get_lv(src) //Running formula [4%*baselevel]
				if (sc && getSCE('SC_SPURT'))
					//Spurt formula [8%*baselevel]
					skillratio *= 2
			} else skillratio += -70 + 10 * skill_lv
			break
		case 'GS_TRIPLEACTION':
			skillratio += 50 * skill_lv
			break
		case 'GS_BULLSEYE':
			//Only works well against brute/demihumans non bosses.
			if (
				(tstatus.race === 'RC_BRUTE' ||
					tstatus.race === 'RC_DEMIHUMAN' ||
					tstatus.race === 'RC_PLAYER_HUMAN' ||
					tstatus.race === 'RC_PLAYER_DORAM') &&
				!status_has_mode(tstatus, 'MD_STATUSIMMUNE')
			)
				skillratio += 400
			break
		case 'GS_TRACKING':
			skillratio += 100 * (skill_lv + 1)
			break
		case 'GS_PIERCINGSHOT':
			if (sd && sd.weapontype1 === 'W_RIFLE')
				skillratio += 150 + 30 * skill_lv
			else skillratio += 100 + 20 * skill_lv
			break
		case 'GS_RAPIDSHOWER':
			skillratio += 400 + 50 * skill_lv
			break
		case 'GS_DESPERADO':
			skillratio += 50 * (skill_lv - 1)
			if (sc && getSCE('SC_FALLEN_ANGEL')) skillratio *= 2
			break
		case 'GS_DUST':
			skillratio += 50 * skill_lv
			break
		case 'GS_FULLBUSTER':
			skillratio += 100 * (skill_lv + 2)
			break
		case 'GS_SPREADATTACK':
			skillratio += 30 * skill_lv
			break
		case 'GS_GROUNDDRIFT':
			skillratio += 100 + 20 * skill_lv
			break
		case 'NJ_HUUMA':
			skillratio += -150 + 250 * skill_lv
			break
		case 'NJ_TATAMIGAESHI':
			skillratio += 10 * skill_lv
			skillratio *= 2
			break
		case 'NJ_KASUMIKIRI':
			skillratio += 20 * skill_lv
			break
		case 'NJ_KIRIKAGE':
			skillratio += -50 + 150 * skill_lv
			break
		case 'NJ_SYURIKEN':
			skillratio += 5 * skill_lv
			break
		case 'NJ_KUNAI':
			skillratio += -100 + 100 * skill_lv
			break
		case 'KN_CHARGEATK':
			skillratio += 600
			break
		case 'AS_VENOMKNIFE':
			skillratio += 400
			break
		case 'HT_PHANTASMIC':
			skillratio += 400
			break
		case 'MO_BALKYOUNG':
			skillratio += 700
			break
		case 'HFLI_MOON': //[orn]
			skillratio += 10 + 110 * skill_lv
			break
		case 'HFLI_SBR44': //[orn]
			skillratio += 100 * (skill_lv - 1)
			break
		case 'NPC_VAMPIRE_GIFT':
			skillratio += (((skill_lv - 1) % 5) + 1) * 100
			break
		case 'RK_SONICWAVE':
			// skillratio += -100 + 500 + 100 * skill_lv
			// skillratio += (src.baseLevel - 100) / 2
			// October 13th, 2022 update
			skillratio += -100 + 1050 + 150 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RK_HUNDREDSPEAR':
			// skillratio += -100 + 600 + 80 * skill_lv
			// if (sd) skillratio += 50 * pc_checkskill(sd, 'LK_SPIRALPIERCE')
			// skillratio *= RE_LVL_DMOD(100)
			// October 13th, 2022 update
			skillratio += -100 + 600 + 200 * skill_lv
			if (sd) skillratio += 50 * pc_checkskill(sd, 'LK_SPIRALPIERCE')
			if (sc) {
				if (getSCE('SC_DRAGONIC_AURA')) {
					skillratio += getSCE('SC_DRAGONIC_AURA').val1 * 160
				}

				if (
					getSCE('SC_CHARGINGPIERCE_COUNT') &&
					getSCE('SC_CHARGINGPIERCE_COUNT').val1 >= 10
				)
					skillratio *= 2
			}
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RK_WINDCUTTER':
			// skillratio += -100 + 100 + 50 * skill_lv
			// October 13th, 2022 update
			if (sd) {
				if (sd.weapontype1 === 'W_2HSWORD')
					skillratio += -100 + 250 * skill_lv
				else if (
					sd.weapontype1 === 'W_1HSPEAR' ||
					sd.weapontype1 === 'W_2HSPEAR'
				)
					skillratio += -100 + 400 * skill_lv
				else skillratio += -100 + 300 * skill_lv
			} else skillratio += -100 + 300 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RK_IGNITIONBREAK':
			// skillratio += -100 + 300 * skill_lv
			// skillratio *= RE_LVL_DMOD(100)
			// October 13th, 2022 update
			skillratio += -100 + 450 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'NPC_IGNITIONBREAK':
			// 3x3 cell Damage   = 1000  1500  2000  2500  3000 %
			// 7x7 cell Damage   = 750   1250  1750  2250  2750 %
			// 11x11 cell Damage = 500   1000  1500  2000  2500 %
			i = distance_bl(src, target)
			if (i < 2) skillratio += -100 + 500 * (skill_lv + 1)
			else if (i < 4) skillratio += -100 + 250 + 500 * skill_lv
			else skillratio += -100 + 500 * skill_lv
			break
		case 'RK_STORMBLAST':
			skillratio +=
				-100 +
				((sd ? pc_checkskill(sd, 'RK_RUNEMASTERY') : 0) +
					sstatus.str / 6) *
					100 // ATK = [{Rune Mastery Skill Level + (Caster's STR / 6)} x 100] %
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RK_PHANTOMTHRUST': // ATK = [{(Skill Level x 50) + (Spear Master Level x 10)} x Caster's Base Level / 150] %
			skillratio +=
				-100 +
				50 * skill_lv +
				10 * (sd ? pc_checkskill(sd, 'KN_SPEARMASTERY') : 5)
			skillratio *= RE_LVL_DMOD(150) // Base level bonus.
			break
		// case "NPC_PHANTOMTHRUST":	// ATK = 100% for all level
		case 'GC_CROSSIMPACT':
			skillratio += -100 + 1400 + 150 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'GC_COUNTERSLASH':
			//ATK [{(Skill Level x 150) + 300} x Caster's Base Level / 120]% + ATK [(AGI x 2) + (Caster's Job Level x 4)]%
			skillratio += -100 + 300 + 150 * skill_lv
			skillratio *= RE_LVL_DMOD(120)
			break
		case 'GC_VENOMPRESSURE':
			skillratio += 900
			break
		case 'GC_PHANTOMMENACE':
			skillratio += 200
			break
		case 'GC_ROLLINGCUTTER':
			skillratio += -100 + 50 + 80 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'GC_CROSSRIPPERSLASHER':
			skillratio += -100 + 80 * skill_lv + sstatus.agi * 3
			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_ROLLINGCUTTER'))
				skillratio += getSCE('SC_ROLLINGCUTTER').val1 * 200
			break
		case 'GC_DARKCROW':
			skillratio += 100 * (skill_lv - 1)
			break
		case 'AB_DUPLELIGHT_MELEE':
			skillratio += 50 + 15 * skill_lv
			break
		case 'NPC_ARROWSTORM':
			if (skill_lv > 4) skillratio += 1900
			else skillratio += 900
			break
		case 'NPC_DRAGONBREATH':
			if (skill_lv > 5) skillratio += 500 + 500 * (skill_lv - 5)
			// Level 6-10 is using water element, like RK_DRAGONBREATH_WATER
			else skillratio += 500 + 500 * skill_lv // Level 1-5 is using fire element, like RK_DRAGONBREATH
			break
		case 'RA_ARROWSTORM':
			if (areRangerSkillsUpdated) {
				if (sc && getSCE('SC_FEARBREEZE'))
					skillratio += -100 + 200 + 250 * skill_lv
				else skillratio += -100 + 200 + 180 * skill_lv
			} else {
				skillratio += -100 + 1000 + 80 * skill_lv
			}

			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RA_AIMEDBOLT':
			if (sc && getSCE('SC_FEARBREEZE') && areRangerSkillsUpdated)
				skillratio += -100 + 800 + 35 * skill_lv
			else skillratio += -100 + 500 + 20 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RA_CLUSTERBOMB':
			skillratio += 100 + 100 * skill_lv
			break
		case 'RA_WUGDASH': // ATK 300%
			skillratio += 200
			break
		case 'RA_WUGSTRIKE':
			skillratio += -100 + 200 * skill_lv
			break
		case 'RA_WUGBITE':
			skillratio += 300 + 200 * skill_lv
			if (skill_lv === 5) skillratio += 100
			break
		case 'RA_SENSITIVEKEEN':
			skillratio += 50 * skill_lv
			break
		case 'NC_BOOSTKNUCKLE':
			skillratio += -100 + 260 * skill_lv + sstatus.dex // !TODO: What's the DEX bonus?
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'NC_PILEBUNKER':
			skillratio += 200 + 100 * skill_lv + status_get_str(src)
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'NC_VULCANARM':
			if (areMechanicSkillsUpdated) {
				// skillratio += -100 + 230 * skill_lv + sstatus.dex // !TODO: What's the DEX bonus?
				skillratio += -100 + 140 * skill_lv + sstatus.dex // !TODO: What's the DEX bonus?
				skillratio *= RE_LVL_DMOD(100)
			} else {
				skillratio += -100 + 70 * skill_lv + sstatus.dex // !TODO: What's the DEX bonus?
				skillratio *= RE_LVL_DMOD(120)
			}
			break
		case 'NC_FLAMELAUNCHER':
		case 'NC_COLDSLOWER':
			skillratio += 200 + 300 * skill_lv
			skillratio *= RE_LVL_DMOD(150)
			break
		case 'NC_ARMSCANNON':
			if (areMechanicSkillsUpdated) {
				skillratio += -100 + 400 + 350 * skill_lv
				skillratio *= RE_LVL_DMOD(100)
			} else {
				switch (tsd?.size) {
					case 'Small':
						skillratio += -100 + 300 + 400 * skill_lv
						break
					case 'Large':
						skillratio += -100 + 300 + 300 * skill_lv
						break
					case 'Medium':
					default:
						skillratio += -100 + 300 + 350 * skill_lv
						break
				}
				skillratio *= RE_LVL_DMOD(120)
			}

			break
		case 'NC_AXEBOOMERANG':
			skillratio += 150 + 50 * skill_lv
			if (sd) {
				let index = sd.equip_index['EQI_HAND_R']

				if (
					index !== 0 &&
					sd.inventory_data[index] &&
					sd.inventory_data[index].Type === 'Weapon'
				)
					skillratio += sd.inventory_data[index].Weight / 10 // Weight is divided by 10 since 10 weight in coding make 1 whole actual weight. [Rytech]
			}
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'NC_POWERSWING': // According to current sources, only the str + dex gets modified by level [Akinari]
			skillratio +=
				-100 + (sstatus.str + sstatus.dex) / 2 + 300 + 100 * skill_lv
			if (areMechanicSkillsUpdated) skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_ABR_BATTLE_WARIOR')) skillratio *= 2
			break
		case 'NC_MAGMA_ERUPTION': // 'Slam' damage
			skillratio += 350 + 50 * skill_lv
			break
		case 'NC_AXETORNADO':
			if (areMechanicSkillsUpdated)
				skillratio += -100 + 200 + 180 * skill_lv + sstatus.vit
			else skillratio += -100 + 200 + 100 * skill_lv + sstatus.vit
			if (sc && getSCE('SC_AXE_STOMP')) skillratio += sstatus.vit
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SC_FATALMENACE':
			if (areShadowChaserSkillsUpdated)
				skillratio += 120 * skill_lv + sstatus.agi
			// !TODO: What's the AGI bonus?
			else skillratio += -100 + 100 * skill_lv

			if (sc !== nullptr && getSCE('SC_ABYSS_DAGGER')) {
				skillratio += 30 * skill_lv
			}

			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SC_TRIANGLESHOT':
			if (areShadowChaserSkillsUpdated) {
				skillratio += -100 + 230 * skill_lv + 3 * sstatus.agi
				skillratio *= RE_LVL_DMOD(100)
			} else {
				skillratio += -100 + 300 + (skill_lv - 1) * 0.5 * sstatus.agi
				skillratio *= RE_LVL_DMOD(150)
			}
			break
		case 'SC_FEINTBOMB':
			skillratio +=
				-100 +
				(((skill_lv + 1) * sstatus.dex) / 2) *
					(sd ? sd.status.job_level / 10 : 1)
			skillratio *= RE_LVL_DMOD(120)
			break
		case 'LG_CANNONSPEAR':
			skillratio += -100 + skill_lv * (50 + sstatus.str)
			skillratio *= RE_LVL_DMOD(100)
			// October 13th, 2022
			// skillratio += -100 + skill_lv * (120 + sstatus.str)

			// if (sc !== nullptr && getSCE('SC_SPEAR_SCAR')) {
			// 	skillratio += 400
			// }
			// skillratio *= RE_LVL_DMOD(100)
			break
		case 'LG_BANISHINGPOINT':
			skillratio += -100 + 50 * skill_lv

			if (sd !== nullptr) {
				skillratio += pc_checkskill(sd, 'SM_BASH') * 30
			}

			if (sc !== nullptr && getSCE('SC_SPEAR_SCAR')) {
				skillratio += 800
			}

			skillratio *= RE_LVL_DMOD(100)
			// October 13th, 2022
			// skillratio += -100 + 100 * skill_lv

			// if (sd !== nullptr) {
			// 	skillratio += pc_checkskill(sd, 'SM_BASH') * 70
			// }

			// if (sc !== nullptr && getSCE('SC_SPEAR_SCAR')) {
			// 	skillratio += 800
			// }

			// skillratio *= RE_LVL_DMOD(100)
			break
		case 'LG_SHIELDPRESS':
			skillratio += -100 + 200 * skill_lv + sstatus.str
			if (sd) {
				if (sc !== nullptr && getSCE('SC_SHIELD_POWER')) {
					skillratio +=
						skill_lv * 15 * pc_checkskill(sd, 'IG_SHIELD_MASTERY')
				}

				let index = sd.equip_index['EQI_HAND_L']

				if (
					index !== 0 &&
					sd.inventory_data[index] &&
					sd.inventory_data[index].Type === 'Armor'
				)
					skillratio += sd.inventory_data[index].Weight / 10
			}
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'LG_PINPOINTATTACK':
			skillratio += -100 + 100 * skill_lv + 5 * status_get_agi(src)
			skillratio *= RE_LVL_DMOD(120)
			break
		case 'LG_RAGEBURST':
			if (sd && sd.spiritball_old)
				skillratio +=
					-100 +
					200 * sd.spiritball_old +
					(status_get_max_hp(src) - status_get_hp(src)) / 100
			else
				skillratio +=
					2900 + (status_get_max_hp(src) - status_get_hp(src))
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'LG_MOONSLASHER':
			skillratio +=
				-100 +
				120 * skill_lv +
				(sd ? pc_checkskill(sd, 'LG_OVERBRAND') * 80 : 0)
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'LG_OVERBRAND':
			skillratio += -100 + 200 * skill_lv
			skillratio += sd ? pc_checkskill(sd, 'CR_SPEARQUICKEN') * 50 : 0
			skillratio *= RE_LVL_DMOD(100)
			skillratio +=
				(100 * skill_lv + sstatus.str + sstatus.dex) * RE_LVL_DMOD(100) //both pierce and swing damage
			// October 13th, 2022
			// if (sc && getSCE('SC_OVERBRANDREADY'))
			// 	skillratio += -100 + 500 * skill_lv
			// else skillratio += -100 + 350 * skill_lv
			// skillratio += sd ? pc_checkskill(sd, 'CR_SPEARQUICKEN') * 50 : 0
			// skillratio *= RE_LVL_DMOD(100)
			break
		case 'LG_EARTHDRIVE':
			{
				let index = sd.equip_index['EQI_HAND_L']
				if (
					index !== 0 &&
					sd.inventory_data[index] &&
					sd.inventory_data[index].Type === 'Armor'
				)
					skillratio += sd.inventory_data[index].Weight / 10
			}

			skillratio *= RE_LVL_DMOD(100)
			// October 13th, 2022
			// skillratio += -100 + 380 * skill_lv + sstatus.str + sstatus.vit // !TODO: What's the STR/VIT bonus?

			// if (sc !== nullptr && getSCE('SC_SHIELD_POWER')) {
			// 	skillratio +=
			// 		skill_lv * 37 * pc_checkskill(sd, 'IG_SHIELD_MASTERY')
			// }

			// skillratio *= RE_LVL_DMOD(100)
			break
		case 'LG_HESPERUSLIT':
			skillratio += -100 + 120 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			// October 13th, 2022
			// if (sc && getSCE('SC_INSPIRATION'))
			// 	skillratio += -100 + 450 * skill_lv
			// else skillratio += -100 + 300 * skill_lv
			// skillratio += sstatus.vit / 6 // !TODO: What's the VIT bonus?
			// skillratio *= RE_LVL_DMOD(100)
			break
		case 'SR_EARTHSHAKER':
			// if (
			// 	tsc &&
			// 	(tsc.option & (OPTION_HIDE | OPTION_CLOAK | OPTION_CHASEWALK) ||
			// 		tgetSCE('SC_CAMOUFLAGE') ||
			// 		tgetSCE('SC_STEALTHFIELD') ||
			// 		tgetSCE('SC__SHADOWFORM'))
			// ) {
			// 	//[(Skill Level x 300) x (Caster Base Level / 100) + (Caster STR x 3)] %
			// 	skillratio += -100 + 300 * skill_lv
			// 	skillratio *= RE_LVL_DMOD(100)
			// 	skillratio += status_get_str(src) * 3
			// } else {
			//[(Skill Level x 400) x (Caster Base Level / 100) + (Caster STR x 2)] %
			skillratio += -100 + 400 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			// skillratio += status_get_str(src) * 3
			skillratio += status_get_int(src) * 2
			// }
			break

		case 'SR_DRAGONCOMBO':
			// skillratio += 100 + 80 * skill_lv//SKill balance, note: +100 ??? should not be +100
			if (areSuraSkillsUpdated) skillratio += 80 * skill_lv
			else skillratio += 40 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SR_FALLENEMPIRE':
			// ATK [(Skill Level x 300 + 100) x Caster Base Level / 150] %
			if (areSuraSkillsUpdated) skillratio += 300 * skill_lv
			else skillratio += 250 * skill_lv
			skillratio *= RE_LVL_DMOD(150)
			break
		case 'SR_TIGERCANNON':
			let hp = (sstatus.max_hp * (10 + skill_lv * 2)) / 100
			let sp = (sstatus.max_sp * (5 + skill_lv)) / 100

			if (wd.miscflag & 8)
				// Base_Damage = [((Caster consumed HP + SP) / 2) x Caster Base Level / 100] %
				skillratio += -100 + (hp + sp) / 2
			// Base_Damage = [((Caster consumed HP + SP) / 4) x Caster Base Level / 100] %
			else skillratio += -100 + (hp + sp) / 4
			skillratio *= RE_LVL_DMOD(100)

			if (getSCE('SC_GT_REVITALIZE'))
				skillratio += (skillratio * 30) / 100
			break
		case 'SR_SKYNETBLOW':
			//ATK [{(Skill Level x 200) + (Caster AGI)} x Caster Base Level / 100] %
			//
			if (areSuraSkillsUpdated)
				skillratio += -100 + 200 * skill_lv + sstatus.agi / 6
			else skillratio += -100 + 80 * skill_lv + sstatus.agi // !TODO: Confirm AGI bonus
			skillratio *= RE_LVL_DMOD(100)
			break

		case 'SR_RAMPAGEBLASTER':
			if (tsc && tgetSCE('SC_EARTHSHAKER')) {
				skillratio += 1400 + 550 * skill_lv
				skillratio *= RE_LVL_DMOD(120)
			} else {
				skillratio += 900 + 350 * skill_lv
				skillratio *= RE_LVL_DMOD(150)
			}
			if (getSCE('SC_GT_CHANGE')) skillratio += (skillratio * 30) / 100
			break
		case 'SR_KNUCKLEARROW':
			if (wd.miscflag & 4) {
				// ATK [(Skill Level x 150) + (1000 x Target current weight / Maximum weight) + (Target Base Level x 5) x (Caster Base Level / 150)] %
				skillratio += -100 + 150 * skill_lv + status_get_lv(target) * 5
				if (tsd && tsd?.weight)
					skillratio += (100 * tsd?.weight) / tsd?.max_weight
				skillratio *= RE_LVL_DMOD(150)
			} else {
				if (status_get_class_(target) === 'CLASS_BOSS')
					skillratio += 400 + 200 * skill_lv
				// ATK [(Skill Level x 100 + 500) x Caster Base Level / 100] %
				else skillratio += 400 + 100 * skill_lv
				skillratio *= RE_LVL_DMOD(100)
			}
			if (getSCE('SC_GT_CHANGE')) skillratio += (skillratio * 30) / 100
			break
		case 'SR_WINDMILL': // ATK [(Caster Base Level + Caster DEX) x Caster Base Level / 100] %
			skillratio += -100 + status_get_lv(src) + sstatus.dex
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SR_GATEOFHELL':
			if (
				sc &&
				getSCE('SC_COMBO') &&
				getSCE('SC_COMBO').val1 === 'SR_FALLENEMPIRE'
			)
				skillratio += -100 + 800 * skill_lv
			else skillratio += -100 + 500 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			if (getSCE('SC_GT_REVITALIZE'))
				skillratio += (skillratio * 30) / 100
			break
		case 'SR_GENTLETOUCH_QUIET':
			skillratio += -100 + 100 * skill_lv + sstatus.dex
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SR_HOWLINGOFLION':
			if (areSuraSkillsUpdated) {
				skillratio += -100 + 500 * skill_lv
				skillratio *= RE_LVL_DMOD(100)
			} else {
				skillratio += -100 + 300 * skill_lv
				skillratio *= RE_LVL_DMOD(150)
			}
			break
		case 'SR_RIDEINLIGHTNING':
			skillratio += -100 + 40 * skill_lv
			if (sd && sd.status.weapon === 'W_KNUCKLE')
				skillratio += 50 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'WM_SEVERE_RAINSTORM':
		case 'WM_SEVERE_RAINSTORM_MELEE':
			if (areMaestroWandererSkillsUpdated) {
				//ATK [{(Caster DEX / 300 + AGI / 200)} x Caster Base Level / 100] %
				skillratio +=
					-100 +
					100 * skill_lv +
					(sstatus.dex / 300 + sstatus.agi / 200)
				if (wd.miscflag & 4)
					// Whip/Instrument equipped
					skillratio += 20 * skill_lv
			} else {
				skillratio +=
					-100 + (sstatus.dex + sstatus.agi) * (skill_lv / 5)
				if (wd.miscflag & 4)
					// Whip/Instrument equipped
					skillratio *= 1.5
			}

			skillratio *= RE_LVL_DMOD(100)
			break
		case 'WM_GREAT_ECHO':
			if (areMaestroWandererSkillsUpdated) {
				skillratio += -100 + 250 + 500 * skill_lv
				if (sd) {
					skillratio += pc_checkskill(sd, 'WM_LESSON') * 50 // !TODO: Confirm bonus
					if (
						skill_check_pc_partner(
							sd,
							skill_id,
							skill_lv,
							'AREA_SIZE',
							0
						) > 0
					)
						skillratio *= 2
				}
			} else skillratio += -100 + 400 + 200 * skill_lv

			skillratio *= RE_LVL_DMOD(100)
			break
		case 'GN_CART_TORNADO':
			// ATK [( Skill Level x 200 ) + ( Cart Weight / ( 150 - Caster Base STR ))] + ( Cart Remodeling Skill Level x 50 )] %
			if (areGeneticSkillsUpdated) skillratio += -100 + 200 * skill_lv
			else skillratio += -100 + 100 * skill_lv
			if (sd && sd.cart_weight)
				skillratio +=
					// sd.cart_weight / 10 / (150 - Math.min(sd.status.str, 120)) +
					sd.cart_weight / 10 / (150 - sd.status.str) +
					pc_checkskill(sd, 'GN_REMODELING_CART') * 50
			// if (sc && getSCE('SC_BIONIC_WOODENWARRIOR')) skillratio *= 2

			break
		case 'GN_CARTCANNON':
			if (!areGeneticSkillsUpdated) {
				skillratio +=
					-100 +
					60 * skill_lv +
					pc_checkskill(sd, 'GN_REMODELING_CART') *
						50 *
						(sstatus.int_ / 40)
			} else {
				skillratio +=
					-100 +
					(250 + 20 * pc_checkskill(sd, 'GN_REMODELING_CART')) *
						skill_lv +
					(2 * sstatus.int_) /
						(6 - pc_checkskill(sd, 'GN_REMODELING_CART'))
				skillratio *= RE_LVL_DMOD(100)
			}

			break
		case 'GN_SPORE_EXPLOSION':
			if (areGeneticSkillsUpdated)
				skillratio += -100 + 400 + 200 * skill_lv
			else skillratio += -100 + (200 + 150 * skill_lv) + sstatus.int_
			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_BIONIC_WOODEN_FAIRY')) skillratio *= 2
			break
		case 'GN_WALLOFTHORN':
			skillratio += 10 * skill_lv
			break
		case 'GN_CRAZYWEED_ATK':
			if (areGeneticSkillsUpdated)
				skillratio += -100 + 700 + 100 * skill_lv
			else skillratio += -100 + 500 + 100 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'GN_SLINGITEM_RANGEMELEEATK':
			if (sd) {
				switch (sd.itemid) {
					case 'ITEMID_APPLE_BOMB':
						skillratio +=
							200 + status_get_str(src) + status_get_dex(src)
						break
					case 'ITEMID_COCONUT_BOMB':
					case 'ITEMID_PINEAPPLE_BOMB':
						skillratio +=
							700 + status_get_str(src) + status_get_dex(src)
						break
					case 'ITEMID_MELON_BOMB':
						skillratio +=
							400 + status_get_str(src) + status_get_dex(src)
						break
					case 'ITEMID_BANANA_BOMB':
						skillratio +=
							777 + status_get_str(src) + status_get_dex(src)
						break
					case 'ITEMID_BLACK_LUMP':
						skillratio +=
							-100 +
							(status_get_str(src) +
								status_get_agi(src) +
								status_get_dex(src)) /
								3
						break
					case 'ITEMID_BLACK_HARD_LUMP':
						skillratio +=
							-100 +
							(status_get_str(src) +
								status_get_agi(src) +
								status_get_dex(src)) /
								2
						break
					case 'ITEMID_VERY_HARD_LUMP':
						skillratio +=
							-100 +
							status_get_str(src) +
							status_get_agi(src) +
							status_get_dex(src)
						break
					default:
						break
				}
				skillratio *= RE_LVL_DMOD(100)
			}
			break
		case 'GN_HELLS_PLANT_ATK':
			if (areGeneticSkillsUpdated) {
				skillratio +=
					-100 +
					100 * skill_lv +
					sstatus.int_ *
						(sd ? pc_checkskill(sd, 'AM_CANNIBALIZE') : 5) // !TODO: Confirm and Cannibalize bonus
				skillratio *= RE_LVL_DMOD(100)
			} else
				skillratio +=
					-100 +
					(skill_lv * src.baseLevel * 10 +
						((sstatus.int_ * 7) / 2) * (18 + src.jobLevel / 4)) *
						(5 / (10 - pc_checkskill(sd, 'AM_CANNIBALIZE')))

			break
		// Physical Elemantal Spirits Attack Skills
		case 'EL_CIRCLE_OF_FIRE':
		case 'EL_FIRE_BOMB_ATK':
		case 'EL_STONE_RAIN':
			skillratio += 200
			break
		case 'EL_FIRE_WAVE_ATK':
			skillratio += 500
			break
		case 'EL_TIDAL_WEAPON':
			skillratio += 1400
			break
		case 'EL_WIND_SLASH':
			skillratio += 100
			break
		case 'EL_HURRICANE':
			skillratio += 600
			break
		case 'EL_TYPOON_MIS':
		case 'EL_WATER_SCREW_ATK':
			skillratio += 900
			break
		case 'EL_STONE_HAMMER':
			skillratio += 400
			break
		case 'EL_ROCK_CRUSHER':
			skillratio += 700
			break
		case 'KO_JYUMONJIKIRI':
			skillratio += -100 + 200 * skill_lv
			skillratio *= RE_LVL_DMOD(120)
			if (tsc && tgetSCE('SC_JYUMONJIKIRI'))
				skillratio += skill_lv * status_get_lv(src)
			if (sc && getSCE('SC_KAGEMUSYA'))
				skillratio += (skillratio * getSCE('SC_KAGEMUSYA').val2) / 100
			break
		case 'KO_HUUMARANKA':
			skillratio +=
				-100 +
				150 * skill_lv +
				sstatus.str +
				(sd ? pc_checkskill(sd, 'NJ_HUUMA') * 100 : 0)
			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_KAGEMUSYA'))
				skillratio += (skillratio * getSCE('SC_KAGEMUSYA').val2) / 100
			break
		case 'KO_SETSUDAN':
			skillratio += 100 * (skill_lv - 1)
			skillratio *= RE_LVL_DMOD(100)
			if (tsc) {
				// struct status_change_entry *sce;
				let sce = 0

				if (
					(sce = tgetSCE('SC_SPIRIT')) ||
					(sce = tgetSCE('SC_SOULGOLEM')) ||
					(sce = tgetSCE('SC_SOULSHADOW')) ||
					(sce = tgetSCE('SC_SOULFALCON')) ||
					(sce = tgetSCE('SC_SOULFAIRY'))
				)
					// Bonus damage added when target is soul linked.
					skillratio += 200 * sce.val1
			}
			break
		case 'KO_BAKURETSU':
			skillratio +=
				-100 +
				((sd ? pc_checkskill(sd, 'NJ_TOBIDOUGU') : 1) *
					(50 + sstatus.dex / 4) *
					skill_lv *
					4) /
					10
			skillratio *= RE_LVL_DMOD(120)
			skillratio += 10 * (sd ? sd.status.job_level : 1)
			if (sc && getSCE('SC_KAGEMUSYA'))
				skillratio += (skillratio * getSCE('SC_KAGEMUSYA').val2) / 100
			break
		case 'KO_MAKIBISHI':
			skillratio += -100 + 20 * skill_lv
			break
		case 'MH_NEEDLE_OF_PARALYZE':
			skillratio +=
				-100 + (450 * skill_lv * status_get_lv(src)) / 100 + sstatus.dex // !TODO: Confirm Base Level and DEX bonus
			break
		case 'MH_TOXIN_OF_MANDARA':
			skillratio +=
				-100 +
				400 +
				(450 * skill_lv * status_get_lv(src)) / 100 +
				sstatus.dex // !TODO: Confirm Base Level and DEX bonus
			break
		case 'MH_NEEDLE_STINGER':
			skillratio +=
				-100 +
				200 +
				(500 * skill_lv * status_get_lv(src)) / 100 +
				sstatus.dex // !TODO: Confirm Base Level and DEX bonus
			break
		case 'MH_STAHL_HORN':
			skillratio +=
				-100 +
				1000 +
				(300 * skill_lv * status_get_lv(src)) / 150 +
				sstatus.vit // !TODO: Confirm VIT bonus
			break
		case 'MH_GLANZEN_SPIES':
			skillratio +=
				-100 +
				300 +
				(450 * skill_lv * status_get_lv(src)) / 100 +
				sstatus.vit // !TODO: Confirm VIT bonus
			break
		case 'MH_LAVA_SLIDE':
			skillratio += -100 + 50 * skill_lv
			break
		case 'MH_BLAST_FORGE':
			skillratio +=
				-100 + (70 * skill_lv * status_get_lv(src)) / 100 + sstatus.str
			break
		case 'MH_SONIC_CRAW':
			skillratio += -100 + (60 * skill_lv * status_get_lv(src)) / 150
			break
		case 'MH_BLAZING_AND_FURIOUS':
			skillratio +=
				-100 + (80 * skill_lv * status_get_lv(src)) / 100 + sstatus.str
			break
		case 'MH_THE_ONE_FIGHTER_RISES':
			skillratio +=
				-100 + (580 * skill_lv * status_get_lv(src)) / 100 + sstatus.str
			break
		case 'MH_SILVERVEIN_RUSH':
			skillratio +=
				-100 + (250 * skill_lv * status_get_lv(src)) / 100 + sstatus.str // !TODO: Confirm STR bonus
			break
		case 'MH_MIDNIGHT_FRENZY':
			skillratio +=
				-100 + (450 * skill_lv * status_get_lv(src)) / 150 + sstatus.str // !TODO: Confirm STR bonus
			break
		case 'MH_MAGMA_FLOW':
			skillratio +=
				-100 +
				((100 * skill_lv + 3 * status_get_lv(src)) *
					status_get_lv(src)) /
					120
			break
		case 'RL_MASS_SPIRAL':
			skillratio += -100 + 200 * skill_lv
			break
		case 'RL_FIREDANCE':
			skillratio += 100 + 100 * skill_lv
			skillratio += sd ? pc_checkskill(sd, 'GS_DESPERADO') * 20 : 0
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RL_BANISHING_BUSTER':
			skillratio += -100 + 1000 + 200 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RL_S_STORM':
			skillratio += -100 + 1700 + 200 * skill_lv
			break
		case 'RL_SLUGSHOT':
			if (target.type === 'BL_MOB') skillratio += -100 + 1200 * skill_lv
			else skillratio += -100 + 2000 * skill_lv
			skillratio *= 2 + tstatus.size
			break
		case 'RL_D_TAIL':
			skillratio += -100 + 500 + 200 * skill_lv
			if (sd && wd.miscflag & 8) skillratio *= 2
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RL_R_TRIP':
			skillratio += -100 + 350 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RL_R_TRIP_PLUSATK':
			skillratio += -100 + 300 + 300 * skill_lv
			break
		case 'RL_H_MINE':
			if (sd && sd.flicker)
				// Flicker explosion damage: 500 + 300 * SkillLv
				skillratio += -100 + 500 + 300 * skill_lv
			// 200 + 200 * SkillLv
			else skillratio += -100 + 200 + 200 * skill_lv
			break
		case 'RL_HAMMER_OF_GOD':
			skillratio += -100 + 100 * skill_lv
			if (sd) {
				if (wd.miscflag & 8) skillratio += 400 * sd.spiritball_old
				else skillratio += 150 * sd.spiritball_old
			}
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'RL_FIRE_RAIN':
		case 'RL_AM_BLAST':
			skillratio += -100 + 3500 + 300 * skill_lv
			break
		case 'SU_BITE':
			skillratio += 100
			break
		case 'SU_SCRATCH':
			skillratio += -50 + 50 * skill_lv
			break
		case 'SU_SCAROFTAROU':
			skillratio += -100 + 100 * skill_lv
			if (sd && pc_checkskill(sd, 'SU_SPIRITOFLIFE'))
				skillratio +=
					(skillratio * status_get_hp(src)) / status_get_max_hp(src)
			break
		case 'SU_PICKYPECK':
		case 'SU_PICKYPECK_DOUBLE_ATK':
			skillratio += 100 + 100 * skill_lv
			if (status_get_hp(target) < status_get_max_hp(target) / 2)
				skillratio *= 2
			if (sd && pc_checkskill(sd, 'SU_SPIRITOFLIFE'))
				skillratio +=
					(skillratio * status_get_hp(src)) / status_get_max_hp(src)
			break
		case 'SU_LUNATICCARROTBEAT':
		case 'SU_LUNATICCARROTBEAT2':
			skillratio += 100 + 100 * skill_lv + sstatus.str * 5 // !TODO: What's the STR bonus?
			skillratio *= RE_LVL_DMOD(100)
			if (sd && pc_checkskill(sd, 'SU_SPIRITOFLIFE'))
				skillratio +=
					(skillratio * status_get_hp(src)) / status_get_max_hp(src)
			break
		case 'SU_SVG_SPIRIT':
			skillratio += 150 + 150 * skill_lv
			if (sd && pc_checkskill(sd, 'SU_SPIRITOFLIFE'))
				skillratio +=
					(skillratio * status_get_hp(src)) / status_get_max_hp(src)
			break
		case 'SJ_FULLMOONKICK':
			skillratio += 1000 + 100 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_LIGHTOFMOON'))
				skillratio += (skillratio * getSCE('SC_LIGHTOFMOON').val2) / 100
			break
		case 'SJ_NEWMOONKICK':
			skillratio += 600 + 100 * skill_lv
			break
		case 'SJ_STAREMPEROR':
			skillratio += 700 + 200 * skill_lv
			break
		case 'SJ_SOLARBURST':
			skillratio += 900 + 220 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_LIGHTOFSUN'))
				skillratio += (skillratio * getSCE('SC_LIGHTOFSUN').val2) / 100
			break
		case 'SJ_PROMINENCEKICK':
			skillratio += 50 + 50 * skill_lv
			break
		case 'SJ_FALLINGSTAR_ATK':
		case 'SJ_FALLINGSTAR_ATK2':
			skillratio += 100 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_LIGHTOFSTAR'))
				skillratio += (skillratio * getSCE('SC_LIGHTOFSTAR').val2) / 100
			break
		case 'DK_SERVANTWEAPON_ATK':
			skillratio += -100 + 500 + 400 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'DK_SERVANT_W_PHANTOM':
			skillratio += -100 + 200 + 300 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'DK_SERVANT_W_DEMOL':
			skillratio += -100 + 500 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'DK_HACKANDSLASHER':
		case 'DK_HACKANDSLASHER_ATK':
			skillratio += -100 + 300 + 700 * skill_lv
			skillratio += 7 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'DK_DRAGONIC_AURA':
			skillratio += 3650 * skill_lv + 10 * sstatus.pow
			if (tstatus.race === 'RC_DEMIHUMAN' || tstatus.race === 'RC_ANGEL')
				skillratio += 150 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'DK_MADNESS_CRUSHER':
			skillratio += -100 + 400 + 800 * skill_lv + 7 * sstatus.pow
			if (sd !== nullptr) {
				let index = sd.equip_index['EQI_HAND_R']

				if (index !== 0 && sd.inventory_data[index] !== nullptr) {
					skillratio +=
						(sd.inventory_data[index].Weight / 10) *
						sd.inventory_data[index].weapon_level
				}
			}
			skillratio *= RE_LVL_DMOD(100)
			if (
				sc &&
				getSCE('SC_CHARGINGPIERCE_COUNT') &&
				getSCE('SC_CHARGINGPIERCE_COUNT').val1 >= 10
			)
				skillratio *= 2
			break
		case 'DK_STORMSLASH':
			skillratio += -100 + 100 + 170 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_GIANTGROWTH') /*&& rnd() % 100 < 30*/)
				skillratio *= 2
			break
		case 'DK_DRAGONIC_BREATH':
			skillratio += -100 + 50 + 350 * skill_lv
			skillratio += 5 * sstatus.pow
			//TODO: needs official HP/SP scaling [Muh]
			skillratio += sstatus.max_hp / 500 + status_get_max_sp(src) / 40
			if (sc && getSCE('SC_DRAGONIC_AURA'))
				skillratio += sstatus.max_hp / 500 + status_get_max_sp(src) / 40
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_OLEUM_SANCTUM':
			skillratio += -100 + 500 + 2000 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_MASSIVE_F_BLASTER':
			skillratio += -100 + 2150 * skill_lv + 15 * sstatus.pow
			if (tstatus.race === 'RC_BRUTE' || tstatus.race === 'RC_DEMON')
				skillratio += 150 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_EXPOSION_BLASTER':
			skillratio += -100 + 2800 * skill_lv + 15 * sstatus.pow

			if (tsc !== nullptr && tgetSCE('SC_HOLY_OIL')) {
				skillratio += 400 * skill_lv
			}

			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_FIRST_BRAND':
			skillratio += -100 + 1200 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_SECOND_FLAME':
			skillratio += -100 + 200 + 2900 * skill_lv + 9 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_SECOND_FAITH':
			skillratio += -100 + 100 + 2300 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_SECOND_JUDGEMENT':
			skillratio += -100 + 150 + 2600 * skill_lv + 7 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_THIRD_PUNISH':
			skillratio += -100 + 350 + 1500 * skill_lv + 10 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_THIRD_FLAME_BOMB':
			skillratio += -100 + 650 * skill_lv + 10 * sstatus.pow
			skillratio += (sstatus.max_hp * 20) / 100
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IQ_THIRD_CONSECRATION':
			skillratio += -100 + 700 * skill_lv + 10 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IG_GRAND_JUDGEMENT':
			skillratio += -100 + 250 + 1500 * skill_lv + 10 * sstatus.pow
			if (tstatus.race === 'RC_PLANT' || tstatus.race === 'RC_INSECT')
				skillratio += 100 + 150 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			if ((i = pc_checkskill_imperial_guard(sd, 3)) > 0)
				skillratio += (skillratio * i) / 100
			break
		case 'IG_SHIELD_SHOOTING':
			skillratio += -100 + 1400 + 2100 * skill_lv + 5 * sstatus.pow
			skillratio += skill_lv * 15 * pc_checkskill(sd, 'IG_SHIELD_MASTERY')
			if (sd) {
				// Damage affected by the shield's weight and refine. Need official formula. [Rytech]
				let index = sd.equip_index['EQI_HAND_L']

				if (
					index !== 0 &&
					sd.inventory_data[index] &&
					sd.inventory_data[index].Type === 'Armor'
				) {
					skillratio += (sd.inventory_data[index].Weight * 7) / 6 / 10
					skillratio +=
						sd.inventory.u.items_inventory[index].refine * 4
				}
			}
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'IG_OVERSLASH':
			skillratio +=
				-100 +
				(120 + pc_checkskill(sd, 'IG_SPEAR_SWORD_M') * 10) * skill_lv +
				5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			if ((i = pc_checkskill_imperial_guard(sd, 3)) > 0)
				skillratio += (skillratio * i) / 100
			break
		case 'CD_EFFLIGO':
			skillratio += -100 + 1650 * skill_lv + 7 * sstatus.pow
			skillratio += 8 * pc_checkskill(sd, 'CD_MACE_BOOK_M')
			if (tstatus.race === 'RC_UNDEAD' || tstatus.race === 'RC_DEMON') {
				skillratio += 150 * skill_lv
				skillratio += 7 * pc_checkskill(sd, 'CD_MACE_BOOK_M')
			}
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'CD_PETITIO':
			skillratio +=
				-100 +
				(1050 + pc_checkskill(sd, 'CD_MACE_BOOK_M') * 10) * skill_lv +
				5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SHC_DANCING_KNIFE':
			skillratio += -100 + 200 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SHC_SAVAGE_IMPACT':
			skillratio += -100 + 90 * skill_lv + 5 * sstatus.pow

			if (sc !== nullptr && getSCE('SC_SHADOW_EXCEED')) {
				skillratio += 20 * skill_lv + 3 * sstatus.pow // !TODO: check POW ratio
			}

			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SHC_ETERNAL_SLASH':
			skillratio += -100 + 265 * skill_lv + 2 * sstatus.pow

			if (sc !== nullptr && getSCE('SC_SHADOW_EXCEED')) {
				skillratio += 100 * skill_lv + sstatus.pow
			}

			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SHC_SHADOW_STAB':
			skillratio += -100 + 300 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SHC_IMPACT_CRATER':
			skillratio += -100 + 80 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'SHC_FATAL_SHADOW_CROW':
			skillratio += -100 + 1300 * skill_lv + 10 * sstatus.pow
			if (tstatus.race === 'RC_DEMIHUMAN' || tstatus.race === 'RC_DRAGON')
				skillratio += 150 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'MT_AXE_STOMP':
			skillratio += -100 + 350 + 850 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'MT_MIGHTY_SMASH':
			skillratio += -100 + 25 + 180 * skill_lv
			skillratio += 5 * sstatus.pow
			if (sc && getSCE('SC_AXE_STOMP')) {
				skillratio += 25
				skillratio += 5 * sstatus.pow
			}
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'MT_RUSH_QUAKE':
			skillratio += -100 + 3600 * skill_lv + 10 * sstatus.pow
			if (tstatus.race === 'RC_FORMLESS' || tstatus.race === 'RC_INSECT')
				skillratio += 150 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'MT_A_MACHINE': // Formula unknown. Using Dancing Knife's formula for now. [Rytech]
			skillratio += -100 + 200 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'MT_SPARK_BLASTER':
			skillratio += -100 + 250 + 900 * skill_lv
			skillratio += 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'MT_TRIPLE_LASER':
			skillratio += -100 + 550 + 900 * skill_lv
			skillratio += 12 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'ABC_ABYSS_DAGGER':
			skillratio += -100 + 100 + 500 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'ABC_UNLUCKY_RUSH':
			skillratio += -100 + 100 + 300 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'ABC_CHAIN_REACTION_SHOT':
			skillratio += -100 + 850 * skill_lv + 15 * sstatus.con
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'ABC_CHAIN_REACTION_SHOT_ATK':
			skillratio += -100 + 600 + 2350 * skill_lv + 15 * sstatus.con
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'ABC_DEFT_STAB':
			skillratio += -100 + 350 + 550 * skill_lv + 5 * sstatus.pow
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'ABC_FRENZY_SHOT':
			skillratio += -100 + 400 * skill_lv + 5 * sstatus.con
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'WH_HAWKRUSH':
			skillratio += -100 + 500 * skill_lv + 5 * sstatus.con
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'WH_HAWKBOOMERANG': // Affected by trait stats??? CON for sure but the other one unknown. Likely POW. [Rytech]
			skillratio +=
				-100 + 600 * skill_lv + 10 * sstatus.pow + 10 * sstatus.con
			if (tstatus.race === 'RC_BRUTE' || tstatus.race === 'RC_FISH')
				skillratio += (skillratio * 50) / 100
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'WH_GALESTORM':
			skillratio += -100 + 950 * skill_lv + 10 * sstatus.con
			skillratio *= RE_LVL_DMOD(100)
			if (
				sc &&
				getSCE('SC_CALAMITYGALE') &&
				(tstatus.race === 'RC_BRUTE' || tstatus.race === 'RC_FISH')
			)
				skillratio += (skillratio * 50) / 100
			break
		case 'WH_CRESCIVE_BOLT':
			skillratio += -100 + 340 * skill_lv + 5 * sstatus.con
			skillratio *= RE_LVL_DMOD(100)
			if (sc) {
				if (getSCE('SC_CRESCIVEBOLT'))
					skillratio +=
						(skillratio * (10 * getSCE('SC_CRESCIVEBOLT').val1)) /
						100

				if (getSCE('SC_CALAMITYGALE')) {
					skillratio += (skillratio * 20) / 100

					if (
						tstatus.race === 'RC_BRUTE' ||
						tstatus.race === 'RC_FISH'
					)
						skillratio += (skillratio * 50) / 100
				}
			}
			break
		case 'WH_DEEPBLINDTRAP':
		case 'WH_SOLIDTRAP':
		case 'WH_SWIFTTRAP':
		case 'WH_FLAMETRAP':
			skillratio += -100 + 850 * skill_lv + 5 * sstatus.con
			skillratio *= RE_LVL_DMOD(100)
			skillratio +=
				(skillratio *
					(20 * (sd ? pc_checkskill(sd, 'WH_ADVANCED_TRAP') : 5))) /
				100
			break
		case 'BO_ACIDIFIED_ZONE_WATER':
		case 'BO_ACIDIFIED_ZONE_GROUND':
		case 'BO_ACIDIFIED_ZONE_WIND':
		case 'BO_ACIDIFIED_ZONE_FIRE':
		case 'BO_ACIDIFIED_ZONE_WATER_ATK': // These deal the same damage? [Rytech]
		case 'BO_ACIDIFIED_ZONE_GROUND_ATK':
		case 'BO_ACIDIFIED_ZONE_WIND_ATK':
		case 'BO_ACIDIFIED_ZONE_FIRE_ATK':
			skillratio += -100 + 400 * skill_lv + 5 * sstatus.pow

			if (sc !== nullptr && getSCE('SC_RESEARCHREPORT')) {
				skillratio += (skillratio * 50) / 100

				if (
					tstatus.race === 'RC_FORMLESS' ||
					tstatus.race === 'RC_PLANT'
				)
					skillratio += (skillratio * 50) / 100
			}

			skillratio *= RE_LVL_DMOD(100)
			break
		case 'BO_EXPLOSIVE_POWDER':
			skillratio += -100 + 400 + 550 * skill_lv
			skillratio += 5 * sstatus.pow
			if (sc && getSCE('SC_RESEARCHREPORT')) skillratio += 100 * skill_lv
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'BO_MAYHEMIC_THORNS':
			skillratio += -100 + 200 + 300 * skill_lv
			skillratio += 5 * sstatus.pow
			if (sc && getSCE('SC_RESEARCHREPORT')) skillratio += 150
			skillratio *= RE_LVL_DMOD(100)
			break
		case 'TR_ROSEBLOSSOM':
			skillratio += -100 + 200 + 2000 * skill_lv

			if (sd && pc_checkskill(sd, 'TR_STAGE_MANNER') > 0)
				skillratio += 3 * sstatus.con

			if (tsc !== nullptr && tgetSCE('SC_SOUNDBLEND')) {
				skillratio += 200 * skill_lv
			}

			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_MYSTIC_SYMPHONY')) {
				skillratio *= 2

				if (
					tstatus.race === 'RC_FISH' ||
					tstatus.race === 'RC_DEMIHUMAN'
				)
					skillratio += (skillratio * 50) / 100
			}
			break
		case 'TR_ROSEBLOSSOM_ATK':
			skillratio += -100 + 250 + 2800 * skill_lv

			if (sd && pc_checkskill(sd, 'TR_STAGE_MANNER') > 0)
				skillratio += 3 * sstatus.con

			if (tsc !== nullptr && tgetSCE('SC_SOUNDBLEND')) {
				skillratio += 200 * skill_lv
			}

			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_MYSTIC_SYMPHONY')) {
				skillratio *= 2

				if (
					tstatus.race === 'RC_FISH' ||
					tstatus.race === 'RC_DEMIHUMAN'
				)
					skillratio += (skillratio * 50) / 100
			}
			break
		case 'TR_RHYTHMSHOOTING':
			skillratio += -100 + 200 + 120 * skill_lv

			if (sd && pc_checkskill(sd, 'TR_STAGE_MANNER') > 0)
				skillratio += 3 * sstatus.con

			if (tsc && tgetSCE('SC_SOUNDBLEND'))
				skillratio += 100 + 100 * skill_lv

			skillratio *= RE_LVL_DMOD(100)
			if (sc && getSCE('SC_MYSTIC_SYMPHONY')) {
				skillratio *= 2

				if (
					tstatus.race === 'RC_FISH' ||
					tstatus.race === 'RC_DEMIHUMAN'
				)
					skillratio += (skillratio * 50) / 100
			}
			break
		case 'ABR_BATTLE_BUSTER': // Need official formula.
		case 'ABR_DUAL_CANNON_FIRE': // Need official formula.
			skillratio += -100 + 8000
			break
		case 'ABR_INFINITY_BUSTER': // Need official formula.
			skillratio += -100 + 50000
			break
		//Magic
		case 'MG_NAPALMBEAT':
			skillratio += -30 + 10 * skill_lv
			break
		case 'MG_FIREBALL':
			skillratio += 40 + 20 * skill_lv
			// 			if(ad.miscflag === 2) //Enemies at the edge of the area will take 75% of the damage
			// 				skillratio = skillratio * 3 / 4;
			break
		case 'MG_SOULSTRIKE':
			// if (battle_check_undead(tstatus.race,tstatus.def_ele))
			skillratio += 5 * skill_lv
			break
		case 'MG_FIREWALL':
			skillratio -= 50
			break
		case 'MG_FIREBOLT':
		case 'MG_COLDBOLT':
		case 'MG_LIGHTNINGBOLT':
			if (sc) {
				if (
					(skill_id === 'MG_FIREBOLT' &&
						getSCE('SC_FLAMETECHNIC_OPTION')) ||
					(skill_id === 'MG_COLDBOLT' &&
						getSCE('SC_COLD_FORCE_OPTION')) ||
					(skill_id === 'MG_LIGHTNINGBOLT' &&
						getSCE('SC_GRACE_BREEZE_OPTION'))
				)
					skillratio *= 2

				// if (getSCE('SC_SPELLFIST') && mflag & BF_SHORT) {
				if (getSCE('SC_SPELLFIST')) {
					skillratio +=
						getSCE('SC_SPELLFIST').val3 * 100 +
						(getSCE('SC_SPELLFIST').val1 * 50 - 50) -
						100 // val3 = used bolt level, val1 = used spellfist level. [Rytech]
					// ad.div_ = 1; // ad mods, to make it work similar to regular hits [Xazax]
					// ad.flag = BF_WEAPON | BF_SHORT;
					// ad.type = DMG_NORMAL;
				}
			}
			break
		case 'MG_THUNDERSTORM':
			// in Renewal Thunder Storm boost is 100% (in pre-re, 80%)
			break
		case 'MG_FROSTDIVER':
			skillratio += 10 * skill_lv
			break
		case 'AL_HOLYLIGHT':
			skillratio += 25
			if (
				sd &&
				getSCE('SC_SPIRIT') &&
				getSCE('SC_SPIRIT').val2 === 'SL_PRIEST'
			)
				skillratio *= 5 //Does 5x damage include bonuses from other skills?
			break
		case 'AL_RUWACH':
			skillratio += 45
			break
		case 'WZ_FROSTNOVA':
			skillratio += -100 + ((100 + skill_lv * 10) * 2) / 3
			break
		case 'WZ_FIREPILLAR':
			// if (sd && ad.div_ > 0)
			// 	ad.div_ *= -1; //For players, damage is divided by number of hits
			skillratio += -60 + 20 * skill_lv //20% MATK each hit
			break
		case 'WZ_SIGHTRASHER':
			skillratio += 20 * skill_lv
			break
		case 'WZ_WATERBALL':
			skillratio += 30 * skill_lv
			break
		case 'WZ_STORMGUST':
			skillratio -= 30 // Offset only once
			skillratio += 50 * skill_lv
			break
		case 'WZ_EARTHSPIKE':
			skillratio += 100
			if (sc && getSCE('SC_EARTH_CARE_OPTION'))
				skillratio += (skillratio * 80) / 100
			break
		case 'HW_NAPALMVULCAN':
			skillratio += -100 + 70 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'SL_STIN': //Target size must be small (0) for full damage
			skillratio += tstatus.size !== 'SZ_SMALL' ? -99 : 10 * skill_lv
			break
		case 'SL_STUN':
			skillratio += 5 * skill_lv
			break
		case 'SL_SMA': //Base damage is 40% + lv%
			skillratio += -60 + status_get_lv(src)
			break
		case 'NJ_KOUENKA':
			skillratio -= 10
			if (
				sd &&
				sd.spiritcharm_type === 'CHARM_TYPE_FIRE' &&
				sd.spiritcharm > 0
			)
				skillratio += 10 * sd.spiritcharm
			break
		case 'NJ_KAENSIN':
			skillratio -= 50
			if (
				sd &&
				sd.spiritcharm_type === 'CHARM_TYPE_FIRE' &&
				sd.spiritcharm > 0
			)
				skillratio += 20 * sd.spiritcharm
			break
		case 'NJ_BAKUENRYU':
			skillratio += 50 + 150 * skill_lv
			if (
				sd &&
				sd.spiritcharm_type === 'CHARM_TYPE_FIRE' &&
				sd.spiritcharm > 0
			)
				skillratio += 100 * sd.spiritcharm
			break
		case 'NJ_HYOUSENSOU':
			skillratio -= 30
			if (sc && getSCE('SC_SUITON')) skillratio += 2 * skill_lv
			if (
				sd &&
				sd.spiritcharm_type === 'CHARM_TYPE_WATER' &&
				sd.spiritcharm > 0
			)
				skillratio += 20 * sd.spiritcharm
			break
		case 'NJ_HYOUSYOURAKU':
			skillratio += 50 * skill_lv
			if (
				sd &&
				sd.spiritcharm_type === 'CHARM_TYPE_WATER' &&
				sd.spiritcharm > 0
			)
				skillratio += 100 * sd.spiritcharm
			break
		case 'NJ_RAIGEKISAI':
			skillratio += 100 * skill_lv
			if (
				sd &&
				sd.spiritcharm_type === 'CHARM_TYPE_WIND' &&
				sd.spiritcharm > 0
			)
				skillratio += 20 * sd.spiritcharm
			break
		case 'NJ_KAMAITACHI':
			skillratio += 100 * skill_lv
			if (
				sd &&
				sd.spiritcharm_type === 'CHARM_TYPE_WIND' &&
				sd.spiritcharm > 0
			)
				skillratio += 100 * sd.spiritcharm
			break
		case 'NJ_HUUJIN':
			skillratio += 50
			if (
				sd &&
				sd.spiritcharm_type === 'CHARM_TYPE_WIND' &&
				sd.spiritcharm > 0
			)
				skillratio += 10 * sd.spiritcharm
			break
		case 'NPC_ENERGYDRAIN':
			skillratio += 100 * skill_lv
			break
		case 'WZ_HEAVENDRIVE':
		case 'NPC_GROUNDDRIVE':
			skillratio += 25
			break
		case 'WZ_METEOR':
			skillratio += 25
			break
		case 'WZ_VERMILION':
			if (sd) skillratio += 300 + skill_lv * 100
			else skillratio += 20 * skill_lv - 20 //Monsters use old formula
			break
		case 'PR_MAGNUS':
			// if (battle_check_undead(tstatus.race, tstatus.def_ele) || tstatus.race === RC_DEMON)
			skillratio += 30
			break
		case 'BA_DISSONANCE':
			skillratio += skill_lv * 10
			if (sd) skillratio += 3 * pc_checkskill(sd, 'BA_MUSICALLESSON')
			break
		case 'HW_GRAVITATION':
			skillratio += -100 + 100 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'PA_PRESSURE':
			skillratio += -100 + 500 + 150 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'WZ_SIGHTBLASTER':
			skillratio += 500
			break
		case 'AB_JUDEX':
			if (areArchBishopSkillsUpdated)
				skillratio += -100 + 300 + 70 * skill_lv
			else skillratio += -100 + 300 + 40 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'AB_ADORAMUS':
			if (areArchBishopSkillsUpdated)
				skillratio += -100 + 300 + 250 * skill_lv
			else skillratio += -100 + 300 + 70 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'AB_DUPLELIGHT_MAGIC':
			skillratio += 300 + 40 * skill_lv
			break
		case 'WL_SOULEXPANSION':
			skillratio += -100 + 400 + skill_lv * 100 + sstatus.int_
			RE_LVL_DMOD(100)
			// October 13th, 2022
			// skillratio += -100 + 1000 + skill_lv * 200 + sstatus.int_ / 6 // !TODO: Confirm INT bonus
			// RE_LVL_DMOD(100)
			break
		case 'WL_FROSTMISTY':
			skillratio += -100 + 200 + 100 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'NPC_JACKFROST':
			if (tsc && tgetSCE('SC_FREEZING')) {
				skillratio += 900 + 300 * skill_lv
				RE_LVL_DMOD(100)
			} else {
				skillratio += 400 + 100 * skill_lv
				RE_LVL_DMOD(150)
			}
			break
		case 'WL_JACKFROST':
			if (tsc && tgetSCE('SC_MISTY_FROST'))
				skillratio += -100 + 1000 + 300 * skill_lv
			else skillratio += -100 + 500 + 100 * skill_lv
			RE_LVL_DMOD(100)
			// October 13th, 2022
			// if (tsc && tgetSCE('SC_MISTY_FROST'))
			// 	skillratio += -100 + 1200 + 600 * skill_lv
			// else skillratio += -100 + 1000 + 300 * skill_lv
			// RE_LVL_DMOD(100)
			break
		case 'WL_DRAINLIFE':
			skillratio += -100 + 200 * skill_lv + sstatus.int_
			RE_LVL_DMOD(100)
			break
		case 'WL_CRIMSONROCK':
			skillratio += -100 + 300 * skill_lv
			RE_LVL_DMOD(100)
			skillratio += 1300 //weird but it's on irowiki formula, need to be confirmed
			// October 13th, 2022
			// skillratio += -100 + 700 + 600 * skill_lv
			// RE_LVL_DMOD(100)
			break
		case 'WL_HELLINFERNO':
			skillratio += -100 + 60 * skill_lv
			// if (mflag & 2) // ELE_DARK
			// 	skillratio = 240 * skill_lv;
			// October 13th, 2022
			// skillratio += -100 + 400 * skill_lv
			// // if (mflag & 2) // ELE_DARK
			// // 	skillratio += 200;
			RE_LVL_DMOD(100)
			break
		case 'WL_COMET':
			skillratio += -100 + 2500 + 500 * skill_lv
			RE_LVL_DMOD(120)
			// October 13th, 2022
			// skillratio += -100 + 2500 + 700 * skill_lv
			// RE_LVL_DMOD(100)
			break
		case 'WL_CHAINLIGHTNING_ATK':
			skillratio += 400 + 100 * skill_lv
			RE_LVL_DMOD(100)
			// if (mflag > 0)
			// 	skillratio += 100 * mflag;
			break
		case 'WL_EARTHSTRAIN':
			skillratio += -100 + 2000 + 100 * skill_lv
			RE_LVL_DMOD(100)
			// October 13th, 2022
			// skillratio += -100 + 1000 + 600 * skill_lv
			// RE_LVL_DMOD(100)
			break
		case 'WL_TETRAVORTEX_FIRE':
		case 'WL_TETRAVORTEX_WATER':
		case 'WL_TETRAVORTEX_WIND':
		case 'WL_TETRAVORTEX_GROUND':
			skillratio += -100 + 500 + 500 * skill_lv
			// October 13th, 2022
			// skillratio += -100 + 800 + 400 * skill_lv
			break
		case 'WL_SUMMON_ATK_FIRE':
		case 'WL_SUMMON_ATK_WATER':
		case 'WL_SUMMON_ATK_WIND':
		case 'WL_SUMMON_ATK_GROUND':
			skillratio += -100 + 50 + 50 * skill_lv
			// October 13th, 2022
			// skillratio +=
			// 	-100 +
			// 	((1 + skill_lv) / 2) *
			// 		(status_get_lv(src) + (sd ? sd.status.job_level : 0))
			// RE_LVL_DMOD(100) // ! TODO: Confirm new formula
			break
		case 'LG_RAYOFGENESIS':
			skillratio += -100 + 350 * skill_lv + sstatus.int_ // !TODO: What's the INT bonus?
			RE_LVL_DMOD(100)
			break
		case 'NPC_RAYOFGENESIS':
			skillratio += -100 + 200 * skill_lv
			break
		case 'WM_METALICSOUND':
			if (areMaestroWandererSkillsUpdated) {
				skillratio +=
					-100 +
					120 * skill_lv +
					60 * (sd ? pc_checkskill(sd, 'WM_LESSON') : 1)

				if (tsc && tgetSCE('SC_SLEEP')) skillratio += 100 // !TODO: Confirm target sleeping bonus
				RE_LVL_DMOD(100)
			} else {
				skillratio +=
					-100 +
					120 * skill_lv +
					60 * (sd ? pc_checkskill(sd, 'WM_LESSON') : 0)
			}
			if (tsc && tgetSCE('SC_SOUNDBLEND'))
				skillratio += (skillratio * 50) / 100
			break
		case 'WM_REVERBERATION':
		case 'WM_REVERBERATION_MAGIC':
			if (areMaestroWandererSkillsUpdated) {
				// MATK [{(Skill Level x 300) + 400} x Casters Base Level / 100] %

				skillratio += -100 + 700 + 300 * skill_lv

				if (tsc && tgetSCE('SC_SOUNDBLEND'))
					skillratio += (skillratio * 50) / 100
			} else {
				skillratio += -100 + 100 + 100 * skill_lv
			}
			RE_LVL_DMOD(100)
			break

		case 'WM_REVERBERATION_MELEE':
			skillratio += -100 + 300 + 100 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'SO_FIREWALK':
			skillratio += -100 + 60 * skill_lv
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_HEATER_OPTION'))
				skillratio += sd ? sd.status.job_level / 2 : 0
			break
		case 'SO_ELECTRICWALK':
			skillratio += -100 + 60 * skill_lv
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_BLAST_OPTION'))
				skillratio += sd ? sd.status.job_level / 2 : 0
			break
		case 'NPC_FIREWALK':
		case 'NPC_ELECTRICWALK':
			skillratio += -100 + 100 * skill_lv
			break
		case 'SO_EARTHGRAVE':
			if (areSorcererSkillsUpdated)
				skillratio +=
					-100 +
					2 * sstatus.int_ +
					300 * pc_checkskill(sd, 'SA_SEISMICWEAPON') +
					sstatus.int_ * skill_lv
			else
				skillratio +=
					-100 +
					200 * pc_checkskill(sd, 'SA_SEISMICWEAPON') +
					sstatus.int_ * skill_lv

			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_CURSED_SOIL_OPTION'))
				skillratio += sd ? sd.status.job_level * 5 : 0
			break
		case 'SO_DIAMONDDUST':
			if (areSorcererSkillsUpdated)
				skillratio +=
					-100 +
					2 * sstatus.int_ +
					300 * pc_checkskill(sd, 'SA_FROSTWEAPON') +
					sstatus.int_ * skill_lv
			else
				skillratio +=
					-100 +
					200 * pc_checkskill(sd, 'SA_FROSTWEAPON') +
					sstatus.int_ * skill_lv
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_COOLER_OPTION'))
				skillratio += sd ? sd.status.job_level * 5 : 0
			break
		case 'SO_POISON_BUSTER':
			skillratio += -100 + 1000 + 300 * skill_lv + sstatus.int_ / 6 // !TODO: Confirm INT bonus
			if (tsc && tgetSCE('SC_CLOUD_POISON')) skillratio += 200 * skill_lv
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_CURSED_SOIL_OPTION'))
				skillratio += sd ? sd.status.job_level * 5 : 0
			break
		case 'NPC_POISON_BUSTER':
			skillratio += -100 + 1500 * skill_lv
			break
		case 'SO_PSYCHIC_WAVE':
			skillratio += -100 + 70 * skill_lv + 3 * sstatus.int_
			RE_LVL_DMOD(100)
			if (
				sc &&
				(getSCE('SC_HEATER_OPTION') ||
					getSCE('SC_COOLER_OPTION') ||
					getSCE('SC_BLAST_OPTION') ||
					getSCE('SC_CURSED_SOIL_OPTION'))
			)
				skillratio += 20
			break
		case 'NPC_PSYCHIC_WAVE':
			skillratio += -100 + 500 * skill_lv
			break
		case 'SO_CLOUD_KILL':
			skillratio += -100 + 40 * skill_lv
			RE_LVL_DMOD(100)
			if (sc) {
				if (getSCE('SC_CURSED_SOIL_OPTION'))
					skillratio += sd ? sd.status.job_level : 0

				if (getSCE('SC_DEEP_POISONING_OPTION'))
					skillratio += (skillratio * 50) / 100
			}
			break
		case 'NPC_CLOUD_KILL':
			skillratio += -100 + 50 * skill_lv
			break
		case 'SO_VARETYR_SPEAR':
			if (areSorcererSkillsUpdated)
				skillratio +=
					-100 +
					(2 * sstatus.int_ +
						150 *
							(pc_checkskill(sd, 'SO_STRIKING') +
								pc_checkskill(sd, 'SA_LIGHTNINGLOADER')) +
						(sstatus.int_ * skill_lv) / 2) /
						3
			else
				skillratio +=
					-100 +
					(sstatus.int_ * skill_lv) / 2 +
					120 *
						(pc_checkskill(sd, 'SO_STRIKING') +
							pc_checkskill(sd, 'SA_LIGHTNINGLOADER'))
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_BLAST_OPTION'))
				skillratio += sd ? sd.status.job_level * 5 : 0
			break
		case 'GN_DEMONIC_FIRE':
			if (skill_lv > 20)
				// Fire expansion Lv.2
				skillratio +=
					10 + 20 * (skill_lv - 20) + status_get_int(src) * 10
			else if (skill_lv > 10) {
				// Fire expansion Lv.1
				skillratio +=
					10 +
					20 * (skill_lv - 10) +
					status_get_int(src) +
					(sd ? sd.status.job_level : 50)
				RE_LVL_DMOD(100)
			} else skillratio += 10 + 20 * skill_lv
			break
		case 'KO_KAIHOU':
			if (
				sd &&
				sd.spiritcharm_type !== 'CHARM_TYPE_NONE' &&
				sd.spiritcharm > 0
			) {
				skillratio += -100 + 200 * sd.spiritcharm
				RE_LVL_DMOD(100)
				// pc_delspiritcharm(sd, sd.spiritcharm, sd.spiritcharm_type);
			}
			break
		// Magical Elemental Spirits Attack Skills
		case 'EL_FIRE_MANTLE':
		case 'EL_WATER_SCREW':
			skillratio += 900
			break
		case 'EL_FIRE_ARROW':
		case 'EL_ROCK_CRUSHER_ATK':
			skillratio += 200
			break
		case 'EL_FIRE_BOMB':
		case 'EL_ICE_NEEDLE':
		case 'EL_HURRICANE_ATK':
			skillratio += 400
			break
		case 'EL_FIRE_WAVE':
		case 'EL_TYPOON_MIS_ATK':
			skillratio += 1100
			break
		case 'MH_ERASER_CUTTER':
		case 'MH_XENO_SLASHER':
			skillratio +=
				-100 +
				(450 * skill_lv * status_get_lv(src)) / 100 +
				sstatus.int_ // !TODO: Confirm Base Level and INT bonus
			break
		case 'MH_TWISTER_CUTTER':
			skillratio +=
				-100 +
				(480 * skill_lv * status_get_lv(src)) / 100 +
				sstatus.int_ // !TODO: Confirm Base Level and INT bonus
			break
		case 'MH_ABSOLUTE_ZEPHYR':
			skillratio +=
				-100 +
				1000 +
				(450 * skill_lv * status_get_lv(src)) / 100 +
				sstatus.int_ // !TODO: Confirm Base Level and INT bonus
			break
		case 'MH_HEILIGE_STANGE':
			skillratio +=
				-100 +
				1500 +
				(250 * skill_lv * status_get_lv(src)) / 150 +
				sstatus.vit // !TODO: Confirm VIT bonus
			break
		case 'MH_HEILIGE_PFERD':
			skillratio +=
				-100 +
				1200 +
				(350 * skill_lv * status_get_lv(src)) / 100 +
				sstatus.vit // !TODO: Confirm VIT bonus
			break
		case 'MH_POISON_MIST':
			skillratio +=
				-100 + (200 * skill_lv * status_get_lv(src)) / 100 + sstatus.dex // ! TODO: Confirm DEX bonus
			break
		case 'SU_SV_STEMSPEAR':
			skillratio += 600
			break
		case 'SU_CN_METEOR':
		case 'SU_CN_METEOR2':
			skillratio += 100 + 100 * skill_lv + sstatus.int_ * 5 // !TODO: Confirm INT bonus
			RE_LVL_DMOD(100)
			break
		case 'NPC_VENOMFOG':
			skillratio += 600 + 100 * skill_lv
			break
		case 'NPC_COMET':
			// i = (sc ? distance_xy(target.x, target.y, comet_x, comet_y) : 8) / 2;
			// i = cap_value(i, 1, 4);
			// skillratio = 2500 + ((skill_lv - i + 1) * 500);
			break
		case 'NPC_FIRESTORM':
			skillratio += 200
			break
		case 'NPC_HELLBURNING':
			skillratio += 900
			break
		case 'NPC_PULSESTRIKE2':
			skillratio += 100
			break
		case 'SP_CURSEEXPLOSION':
			if (tsc && tgetSCE('SC_SOULCURSE'))
				skillratio += 1400 + 200 * skill_lv
			else skillratio += 300 + 100 * skill_lv
			break
		case 'SP_SPA':
			skillratio += 400 + 250 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'SP_SHA':
			skillratio += -100 + 5 * skill_lv
			break
		case 'SP_SWHOO':
			skillratio += 1000 + 200 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'NPC_STORMGUST2':
			skillratio += 200 * skill_lv
			break
		case 'AG_DEADLY_PROJECTION':
			skillratio += -100 + 2800 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_DESTRUCTIVE_HURRICANE':
			skillratio += -100 + 250 + 2800 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_CLIMAX')) {
				if (getSCE('SC_CLIMAX').val1 === 3) skillratio *= 3
				else if (getSCE('SC_CLIMAX').val1 === 5)
					skillratio += (skillratio * 50) / 100
			}
			break
		case 'AG_RAIN_OF_CRYSTAL':
			skillratio += -100 + 180 + 760 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_MYSTERY_ILLUSION':
			skillratio += -100 + 950 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_VIOLENT_QUAKE_ATK':
			skillratio += -100 + 200 + 1200 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_CLIMAX')) {
				if (getSCE('SC_CLIMAX').val1 === 1) skillratio /= 2
				else if (getSCE('SC_CLIMAX').val1 === 3) skillratio *= 3
			}
			break
		case 'AG_SOUL_VC_STRIKE':
			skillratio += -100 + 250 * skill_lv + 3 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_STRANTUM_TREMOR':
			skillratio += -100 + 100 + 730 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_ALL_BLOOM_ATK':
			skillratio += -100 + 200 + 1200 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_CLIMAX')) {
				if (getSCE('SC_CLIMAX').val1 === 3) skillratio *= 4
			}
			break
		case 'AG_ALL_BLOOM_ATK2': // Is this affected by BaseLV and SPL too??? [Rytech]
			skillratio += -100 + 85000 + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_CRYSTAL_IMPACT':
			skillratio += -100 + 250 + 1300 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_CLIMAX')) {
				if (getSCE('SC_CLIMAX').val1 === 3)
					skillratio += (skillratio * 50) / 100
				else if (getSCE('SC_CLIMAX').val1 === 4) skillratio /= 2
			}
			break
		case 'AG_CRYSTAL_IMPACT_ATK': // Said to deal the same damage as the main attack.
			skillratio += -100 + 800 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_CLIMAX') && getSCE('SC_CLIMAX').val1 === 4)
				skillratio += (skillratio * 150) / 100
			break
		case 'AG_TORNADO_STORM':
			skillratio += -100 + 100 + 760 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_FLORAL_FLARE_ROAD':
			skillratio += -100 + 50 + 740 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_ASTRAL_STRIKE':
			skillratio += -100 + 1800 * skill_lv + 10 * sstatus.spl
			if (tstatus.race === 'RC_UNDEAD' || tstatus.race === 'RC_DRAGON')
				skillratio += 340 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'AG_ASTRAL_STRIKE_ATK':
			skillratio += -100 + 650 * skill_lv + 10 * sstatus.spl
			// Not confirmed, but if the main hit deal additional damage
			// on certain races then the repeated damage should too right?
			// Guessing a formula here for now. [Rytech]
			if (tstatus.race === 'RC_UNDEAD' || tstatus.race === 'RC_DRAGON')
				skillratio += 200 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'AG_ROCK_DOWN':
			skillratio += -100 + 950 * skill_lv + 5 * sstatus.spl

			if (sc !== nullptr && getSCE('SC_CLIMAX')) {
				skillratio += 300 * skill_lv
			}

			RE_LVL_DMOD(100)
			break
		case 'AG_STORM_CANNON':
			skillratio += -100 + 950 * skill_lv + 5 * sstatus.spl

			if (sc !== nullptr && getSCE('SC_CLIMAX')) {
				skillratio += 300 * skill_lv
			}

			RE_LVL_DMOD(100)
			break
		case 'AG_CRIMSON_ARROW':
			skillratio += -100 + 300 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_CRIMSON_ARROW_ATK':
			skillratio += -100 + 600 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'AG_FROZEN_SLASH':
			skillratio += -100 + 250 + 900 * skill_lv + 5 * sstatus.spl

			if (sc !== nullptr && getSCE('SC_CLIMAX')) {
				skillratio += 150 + 350 * skill_lv
			}

			RE_LVL_DMOD(100)
			break
		case 'IG_JUDGEMENT_CROSS':
			skillratio += -100 + 1950 * skill_lv + 10 * sstatus.spl
			if (tstatus.race === 'RC_PLANT' || tstatus.race === 'RC_INSECT')
				skillratio += 150 * skill_lv
			RE_LVL_DMOD(100)
			if ((i = pc_checkskill_imperial_guard(sd, 3)) > 0)
				skillratio += (skillratio * i) / 100
			break
		case 'IG_CROSS_RAIN':
			if (sc && getSCE('SC_HOLY_S')) {
				skillratio +=
					-100 +
					(450 + 10 * pc_checkskill(sd, 'IG_SPEAR_SWORD_M')) *
						skill_lv
			} else {
				skillratio +=
					-100 +
					(320 + 5 * pc_checkskill(sd, 'IG_SPEAR_SWORD_M')) * skill_lv
			}
			skillratio += 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'CD_ARBITRIUM':
			skillratio += -100 + 1000 * skill_lv + 7 * sstatus.spl
			skillratio += 10 * pc_checkskill(sd, 'CD_FIDUS_ANIMUS') * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'CD_ARBITRIUM_ATK':
			skillratio += -100 + 1250 * skill_lv + 7 * sstatus.spl
			skillratio += 10 * pc_checkskill(sd, 'CD_FIDUS_ANIMUS') * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'CD_PNEUMATICUS_PROCELLA':
			skillratio += -100 + 150 + 2100 * skill_lv + 10 * sstatus.spl
			skillratio += 3 * pc_checkskill(sd, 'CD_FIDUS_ANIMUS')
			if (tstatus.race === 'RC_UNDEAD' || tstatus.race === 'RC_DEMON') {
				skillratio += 50 + 150 * skill_lv
				skillratio += 2 * pc_checkskill(sd, 'CD_FIDUS_ANIMUS')
			}
			RE_LVL_DMOD(100)
			break
		case 'CD_FRAMEN':
			skillratio +=
				-100 +
				(800 + 5 * pc_checkskill(sd, 'CD_FIDUS_ANIMUS')) * skill_lv +
				5 * sstatus.spl
			if (tstatus.race === 'RC_UNDEAD' || tstatus.race === 'RC_DEMON')
				skillratio += 100 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'AG_DESTRUCTIVE_HURRICANE_CLIMAX': // Is this affected by BaseLV and SPL too??? [Rytech]
			skillratio += -100 + 500 + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'ABC_ABYSS_STRIKE':
			skillratio += -100 + 2200 * skill_lv + 10 * sstatus.spl
			if (tstatus.race === 'RC_DEMON' || tstatus.race === 'RC_ANGEL')
				skillratio += 150 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'ABC_ABYSS_SQUARE':
			skillratio +=
				-100 +
				(570 + 20 * pc_checkskill(sd, 'ABC_MAGIC_SWORD_M')) * skill_lv +
				5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		// case 'TR_METALIC_FURY': {
		// 		let area = skill_get_splash(skill_id, skill_lv);
		// 		let count = map_forcountinarea(skill_check_bl_sc,target.m,target.x - area,target.y - area,target.x + area,target.y + area,5,BL_MOB,SC_SOUNDBLEND);
		// 		skillratio += -100 + (2200 + 300 * count) * skill_lv + 5 * sstatus.spl;
		// 		RE_LVL_DMOD(100);
		// 	}
		// 	break;
		case 'TR_SOUNDBLEND':
			skillratio += -100 + 120 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			if (sc && getSCE('SC_MYSTIC_SYMPHONY')) {
				skillratio += (skillratio * 100) / 100

				if (
					tstatus.race === 'RC_FISH' ||
					tstatus.race === 'RC_DEMIHUMAN'
				)
					skillratio += (skillratio * 50) / 100
			}
			break
		case 'EM_DIAMOND_STORM':
			skillratio += -100 + 400 + 1550 * skill_lv + 5 * sstatus.spl

			if (sc !== nullptr && getSCE('SC_SUMMON_ELEMENTAL_DILUVIO')) {
				skillratio += 5000 + 250 * skill_lv + 5 * sstatus.spl
			}

			RE_LVL_DMOD(100)
			break
		case 'EM_LIGHTNING_LAND':
			skillratio += -100 + 500 + 650 * skill_lv + 5 * sstatus.spl

			if (sc !== nullptr && getSCE('SC_SUMMON_ELEMENTAL_PROCELLA')) {
				skillratio += 400 * skill_lv
			}

			RE_LVL_DMOD(100)
			break
		case 'EM_VENOM_SWAMP':
			skillratio += -100 + 500 + 650 * skill_lv + 5 * sstatus.spl

			if (sc && getSCE('SC_SUMMON_ELEMENTAL_SERPENS')) {
				skillratio += 400 * skill_lv
			}

			RE_LVL_DMOD(100)
			break
		case 'EM_CONFLAGRATION':
			skillratio += -100 + 500 + 650 * skill_lv + 5 * sstatus.spl

			if (sc !== nullptr && getSCE('SC_SUMMON_ELEMENTAL_ARDOR')) {
				skillratio += 400 * skill_lv
			}

			RE_LVL_DMOD(100)
			break
		case 'EM_TERRA_DRIVE':
			skillratio += -100 + 400 + 1550 * skill_lv + 5 * sstatus.spl

			if (sc !== nullptr && getSCE('SC_SUMMON_ELEMENTAL_TERREMOTUS')) {
				skillratio += 5000 + 250 * skill_lv + 5 * sstatus.spl
			}

			RE_LVL_DMOD(100)
			break
		case 'ABC_FROM_THE_ABYSS_ATK':
			skillratio += -100 + 100 + 500 * skill_lv + 5 * sstatus.spl
			RE_LVL_DMOD(100)
			break
		case 'EM_ELEMENTAL_BUSTER_FIRE':
		case 'EM_ELEMENTAL_BUSTER_WATER':
		case 'EM_ELEMENTAL_BUSTER_WIND':
		case 'EM_ELEMENTAL_BUSTER_GROUND':
		case 'EM_ELEMENTAL_BUSTER_POISON':
			skillratio += -100 + 500 + 2200 * skill_lv + 10 * sstatus.spl
			if (tstatus.race === 'RC_FORMLESS' || tstatus.race === 'RC_DRAGON')
				skillratio += 150 * skill_lv
			RE_LVL_DMOD(100)
			break
		case 'EM_EL_FLAMEROCK':
			skillratio += -100 + 2400
			// if (ed)
			// 	skillratio += skillratio * status_get_lv(&ed.master.bl) / 100;
			break
		case 'EM_EL_AGE_OF_ICE':
			skillratio += -100 + 3700
			// if (ed)
			// 	skillratio += skillratio * status_get_lv(&ed.master.bl) / 100;
			break
		case 'EM_EL_STORM_WIND':
			skillratio += -100 + 2600
			// if (ed)
			// 	skillratio += skillratio * status_get_lv(&ed.master.bl) / 100;
			break
		case 'EM_EL_AVALANCHE':
			skillratio += -100 + 450
			// if (ed)
			// 	skillratio += skillratio * status_get_lv(&ed.master.bl) / 100;
			break
		case 'EM_EL_DEADLY_POISON':
			skillratio += -100 + 700
			// if (ed)
			// 	skillratio += skillratio * status_get_lv(&ed.master.bl) / 100;
			break
		case 'NPC_RAINOFMETEOR':
			skillratio += 350 // unknown ratio
			break
		default:
			break
	}
	return Math.floor(skillratio)
}

/*==================================================================================================
 * Constant skill damage additions are added before SC modifiers and after skill base ATK calculation
 *--------------------------------------------------------------------------------------------------*
 * Credits:
 *	Original coder Skotlex
 *	Initial refactoring by Baalberith
 *	Refined and optimized by helvetica
 */
// export function battle_calc_skill_constant_addition(struct Damage* wd, struct block_list *src,struct block_list *target,uint16 skill_id,uint16 skill_lv)
export function getFlatSkillBonus(wd, src, target, skill_id, skill_lv) {
	let sd = BL_CAST(BL_PC, src)
	// let tsd = BL_CAST(BL_PC, target);
	let sstatus = status_get_status_data(src)
	// let tstatus = status_get_status_data(target);
	let atk = 0

	//Constant/misc additions from skills
	switch (skill_id) {
		case 'MO_EXTREMITYFIST':
			atk = 250 + 150 * skill_lv
			break
		case 'HT_FREEZINGTRAP':
			if (sd) atk = 40 * pc_checkskill(sd, 'RA_RESEARCHTRAP')
			break
		case 'GC_COUNTERSLASH':
			atk = sstatus.agi * 2 + (sd ? sd.status.job_level * 4 : 0)
			break
		case 'LG_SHIELDPRESS':
			if (sd) {
				let damagevalue = 0
				let index = sd.equip_index['EQI_HAND_L']

				if (
					index !== 0 &&
					sd.inventory_data[index] &&
					sd.inventory_data[index].Type === 'Armor'
				)
					damagevalue =
						sstatus.vit *
						sd.inventory.u.items_inventory[index].refine
				atk = damagevalue
			}
			break
		default:
			break
	}
	return atk
}
let BF_LONG = 0x9999
/*==========================================================
 * Calculate basic ATK that goes into the skill ATK formula
 *----------------------------------------------------------
 * Credits:
 *	Original coder Skotlex
 *	Initial refactoring by Baalberith
 *	Refined and optimized by helvetica
 */
//static void battle_calc_skill_base_damage(struct Damage* wd, struct block_list *src,struct block_list *target,uint16 skill_id,uint16 skill_lv)
export function getBaseDamagePreSkillMod(wd, src, target, skill_id, skill_lv) {
	let sc = status_get_sc(src)
	let sstatus = status_get_status_data(src)
	let tstatus = status_get_status_data(target)
	let sd = BL_CAST(BL_PC, src)
	// let tsd = BL_CAST(BL_PC, target)

	let i = 0

	switch (
		skill_id //Calc base damage according to skill
	) {
		case 'PA_SACRIFICE':
			wd.damage = (sstatus.max_hp * 9) / 100
			wd.damage2 = 0
			wd.weaponAtk = wd.damage
			wd.weaponAtk2 = wd.damage2
			break
		case 'LK_SPIRALPIERCE':
		case 'ML_SPIRALPIERCE':
			if (sd) {
				let index = sd.equip_index['EQI_HAND_R']

				if (
					index !== 0 &&
					sd.inventory_data[index] &&
					sd.inventory_data[index].Type === 'Weapon'
				)
					wd.equipAtk += (sd.inventory_data[index].Weight * 7) / 100 // weight from spear is treated as equipment ATK on official [helvetica]

				battle_calc_damage_parts(wd, src, target, skill_id, skill_lv)
				wd.masteryAtk = 0 // weapon mastery is ignored for spiral

				switch (
					tstatus.size //Size-fix. Is this modified by weapon perfection?
				) {
					case 'SZ_SMALL': //Small: 115%
						ATK_RATE(wd.damage, wd.damage2, 115)
						RE_ALLATK_RATE(wd, 115)
						break
					//case "SZ_MEDIUM: //Medium": 100%
					case 'SZ_BIG': //Large": 85%
						ATK_RATE(wd.damage, wd.damage2, 85)
						RE_ALLATK_RATE(wd, 85)
						break
					default:
						break
				}
			} else {
				wd.damage = battle_calc_base_damage(
					src,
					sstatus,
					sstatus.rhw,
					sc,
					tstatus.size,
					0
				) //Monsters have no weight and use ATK instead
			}
			break
		case 'CR_SHIELDBOOMERANG':
		case 'PA_SHIELDCHAIN':
			wd.damage = sstatus.batk
			if (sd) {
				let index = sd.equip_index['EQI_HAND_L']

				if (
					index !== 0 &&
					sd.inventory_data[index] &&
					sd.inventory_data[index].Type === 'Armor'
				) {
					ATK_ADD(
						wd.damage,
						wd.damage2,
						sd.inventory_data[index].Weight / 10
					)
					ATK_ADD(
						wd.weaponAtk,
						wd.weaponAtk2,
						sd.inventory_data[index].Weight / 10
					)
				}
			} else ATK_ADD(wd.damage, wd.damage2, sstatus.rhw.atk2) //Else use Atk2
			break
		case 'RK_DRAGONBREATH':
		case 'RK_DRAGONBREATH_WATER':
			// {
			// 	let damagevalue =
			// 		(sstatus.hp / 50 + status_get_max_sp(src) / 4) * skill_lv
			// 	if (status_get_lv(src) > 100)
			// 		damagevalue = (damagevalue * status_get_lv(src)) / 100
			// 	if (sd) {
			// 		if (pc_checkskill(sd, 'DK_DRAGONIC_AURA') >= 1) {
			// 			damagevalue =
			// 				(damagevalue *
			// 					(95 +
			// 						5 * pc_checkskill(sd, 'RK_DRAGONTRAINING') +
			// 						sstatus.pow / 5)) /
			// 				100
			// 		} else {
			// 			damagevalue =
			// 				(damagevalue *
			// 					(90 +
			// 						10 *
			// 							pc_checkskill(
			// 								sd,
			// 								'RK_DRAGONTRAINING'
			// 							))) /
			// 				100
			// 		}
			// 	}
			// 	if (sc && sc.getSCE('SC_DRAGONIC_AURA'))
			// 		damagevalue +=
			// 			(damagevalue *
			// 				sc.getSCE('SC_DRAGONIC_AURA').val1 *
			// 				10) /
			// 			100
			// 	ATK_ADD(wd.damage, wd.damage2, damagevalue)
			// 	ATK_ADD(wd.weaponAtk, wd.weaponAtk2, damagevalue)
			// 	wd.flag |= BF_LONG
			// }
			// October 13th, 2022
			{
				let damagevalue =
					(sstatus.hp / 50 + status_get_max_sp(src) / 4) * skill_lv
				if (status_get_lv(src) > 100)
					damagevalue = (damagevalue * status_get_lv(src)) / 100
				if (sd) {
					if (pc_checkskill(sd, 'DK_DRAGONIC_AURA') >= 1) {
						damagevalue =
							(damagevalue *
								(90 +
									10 *
										pc_checkskill(sd, 'RK_DRAGONTRAINING') +
									sstatus.pow / 5)) /
							100
					} else {
						damagevalue =
							(damagevalue *
								(90 +
									10 *
										pc_checkskill(
											sd,
											'RK_DRAGONTRAINING'
										))) /
							100
					}
				}
				if (sc && sc.getSCE('SC_DRAGONIC_AURA'))
					damagevalue +=
						(damagevalue *
							sc.getSCE('SC_DRAGONIC_AURA').val1 *
							10) /
						100
				ATK_ADD(wd.damage, wd.damage2, damagevalue)
				ATK_ADD(wd.weaponAtk, wd.weaponAtk2, damagevalue)
				wd.flag |= BF_LONG
			}
			break
		case 'NC_SELFDESTRUCTION':
			{
				let damagevalue =
					(skill_lv + 1) *
					((sd ? pc_checkskill(sd, 'NC_MAINFRAME') : 0) + 8) *
					(status_get_sp(src) + sstatus.vit)

				if (status_get_lv(src) > 100)
					damagevalue = (damagevalue * status_get_lv(src)) / 100
				damagevalue = damagevalue + sstatus.hp
				ATK_ADD(wd.damage, wd.damage2, damagevalue)
				ATK_ADD(wd.weaponAtk, wd.weaponAtk2, damagevalue)
			}
			break
		case 'KO_HAPPOKUNAI':
			if (sd) {
				let index = sd.equip_index['EQI_AMMO']
				let damagevalue =
					(3 *
						(2 * sstatus.batk +
							sstatus.rhw.atk +
							(index !== 0 && sd.inventory_data[index]
								? sd.inventory_data[index].atk
								: 0)) *
						(skill_lv + 5)) /
					5
				if (sc && sc.getSCE('SC_KAGEMUSYA'))
					damagevalue +=
						(damagevalue * sc.getSCE('SC_KAGEMUSYA').val2) / 100
				ATK_ADD(wd.damage, wd.damage2, damagevalue)
				ATK_ADD(wd.weaponAtk, wd.weaponAtk2, damagevalue)
			} else ATK_ADD(wd.damage, wd.damage2, 5000)
			break
		case 'HFLI_SBR44': //[orn]
			//TODO
			// if(src.type === BL_HOM)
			// wd.damage = ((TBL_HOM*)src).homunculus.intimacy ;
			break

		default:
			if (sd)
				battle_calc_damage_parts(wd, src, target, skill_id, skill_lv)
			else {
				i =
					(is_attack_critical(
						wd,
						src,
						target,
						skill_id,
						skill_lv,
						false
					)
						? 1
						: 0) |
					(!skill_id && sc && sc.getSCE('SC_CHANGE') ? 4 : 0)

				wd.damage = battle_calc_base_damage(
					src,
					sstatus,
					sstatus.rhw,
					sc,
					tstatus.size,
					i
				)
				if (is_attack_left_handed(src, skill_id))
					wd.damage2 = battle_calc_base_damage(
						src,
						sstatus,
						sstatus.lhw,
						sc,
						tstatus.size,
						i
					)
			}
			// if (nk['NK_SPLASHSPLIT']) {
			// 	// Divide ATK among targets
			// 	if (wd.miscflag > 0) {
			// 		wd.damage /= wd.miscflag
			// 		wd.statusAtk /= wd.miscflag
			// 		wd.weaponAtk /= wd.miscflag
			// 		wd.equipAtk /= wd.miscflag
			// 		wd.masteryAtk /= wd.miscflag
			// 	} else
			// 		ShowError(
			// 			'0 enemies targeted by %d:%s, divide per 0 avoided!\n',
			// 			skill_id,
			// 			skill_get_name(skill_id)
			// 		)
			// }
			//Add any bonuses that modify the base atk (pre-skills)
			if (sd) {
				let skill
				if ((skill = pc_checkskill(sd, 'TK_POWER')) > 0) {
					ATK_ADDRATE(wd.damage, wd.damage2, 10 + 15 * skill)
					RE_ALLATK_ADDRATE(wd, 10 + 15 * skill)
				}
			}
			break
	} //End switch(skill_id)
}

function pc_checkskill(sd, skill_id) {
	let skill = sd.skillList.find((sk) => sk.AegisName === skill_id)
	return skill ? skill.skillLevel : 0
}

function BL_CAST(val, src) {
	let entity = null

	if (src?.Class === val) {
		entity = {
			skillList: src.skillList,
			status: {
				str: src.Str,
				agi: src.Agi,
				vit: src.Vit,
				int: src.Int,
				dex: src.Dex,
				luk: src.Luk,
				job_level: src.jobLevel,
				weapon: 'W_' + src.Inventory?.Right_Hand.SubType.toUpperCase(),
			},
			cart_weight: 4000,
			cart_weight_max: 8000,
			equip_index: {
				EQI_HAND_L: 'Left_Hand',
				EQI_HAND_R: 'Right_Hand',
			},
			inventory_data: src.Inventory,
			weapontype1: 'W_' + src.Inventory?.Right_Hand.SubType.toUpperCase(),
			spiritball_old: 0, //TODO
			itemid: 0, //TODO skill will be removed with Skill balance patch
			flicker: 0, //TODO
		}
	} else {
		//tsd?.weight) / tsd?.max_weight
		entity = {
			weight: 0,
			max_weight: 0,
			size: src?.Size ? src?.Size : 'Medium',
		}
	}
	return entity
}
function status_get_status_data(src) {
	return {
		str: src?.Str,
		agi: src?.Agi,
		vit: src?.Vit,
		int_: src?.Int,
		dex: src?.Dex,
		luk: src?.Luk,
		hp: src?.Hp,
		max_hp: src?.MaxHp,
		sp: src?.MaxSp,
		max_sp: src?.MaxSp,
	}
}
function status_get_sc(src) {
	return src?.Bonuses ? src.Bonuses : []
}

function status_get_lv(src) {
	return src.baseLevel
}

function status_has_mode(tstatus, skill_id) {
	//TODO
	return 0
}
function pc_checkskill_imperial_guard(sd, amount) {
	//TODO
	return 0
}

function status_get_hp(src) {
	return src.Hp
}
function status_get_max_hp(src) {
	return src.MaxHp
}
function status_get_max_sp(src) {
	return src.MaxSp
}
function status_get_str(src) {
	return src.Str
}
function status_get_agi(src) {
	return src.Agi
}
// eslint-disable-next-line no-unused-vars
function status_get_vit(src) {
	return src.Vit
}
// eslint-disable-next-line no-unused-vars
function status_get_int(src) {
	return src.Int
}
function status_get_dex(src) {
	return src.Dex
}
// eslint-disable-next-line no-unused-vars
function status_get_luk(src) {
	return src.Luk
}
function skill_check_pc_partner(src) {
	//TODO
	return 0
}
function status_get_class_(src) {
	return 'CLASS_' + src.Class.toUpperCase()
}
function distance_bl(src) {
	//TODO
	return 0
}

function battle_calc_damage_parts() {
	//TODO
	return 0
}
function ATK_RATE() {
	//TODO
	return 0
}
function RE_ALLATK_RATE() {
	//TODO
	return 0
}
function battle_calc_base_damage() {
	//TODO
	return 0
}
function ATK_ADD() {
	//TODO
	return 0
}
function status_get_sp() {
	//TODO
	return 0
}
function is_attack_critical() {
	//TODO
	return 0
}
function is_attack_left_handed() {
	//TODO
	return 0
}
// function ShowError() {}
// function skill_get_name() {}
function ATK_ADDRATE() {
	//TODO
	return 0
}
function RE_ALLATK_ADDRATE() {
	//TODO
	return 0
}
